export const BookingStatusOptions = [
    {
        label: 'All',
        value: 'none',
    },
    {
        label: 'Received',
        value: 'RECEIVED',
    },
    {
        label: 'Confirmed',
        value: 'CONFIRMED',
    },

    {
        label: 'Allocation In Progress',
        value: 'ALLOCATION_IN_PROGRESS,ALLOCATION_PENDING',
    },
    {
        label: 'Allocation Closed',
        value: 'ALLOCATION_CLOSED',
    },
    {
        label: 'RTD',
        value: 'READY_TO_DEPLOY',
    },
    {
        label: 'Deployed',
        value: 'DEPLOYED',
    },
    {
        label: 'Cancelled',
        value: 'CANCELLED',
    },
]

export const tags = {
    CARPENTER: ['Modular Furniture', 'Wooden Doors & Windows', 'Solid Wood Furniture', 'Plywood Furniture'],
    BAR_BENDER: ['Manual Barbending', 'Barbending Machine Operator'],
    GENERAL_HELPER: ['Housekeeping', 'Loading/Offloading'],
    ALUMINIUM_FABRICATOR: ['Windows & Doors', 'Partition Works'],
    WELDER_FITTER: ['Structural Fabrication', 'Pre-Engineered Building Structures'],
    PAINTER: [
        'Internal Painting - Plain',
        'External Painting - High Rise',
        'Stucco Painting',
        'Internal Decorative/Texture Painting',
        'Polish & Varnish',
        'Metal Painting',
        'PU/Duco Painting',
    ],
    MASON: [
        'Slab/Column Casting',
        'Concreting/Foundation - PCC/RCC/RMC',
        'External Plastering - High Rise',
        'AAC Blockwork',
        'Brickwork',
        'Plastering',
    ],
    STONE_TILE_MARBLE_LAYER: [
        'Floor & Wall Tiling',
        'Granite & Stone Works',
        'Marble Laying',
        'Intricate Flooring/Wall Stone Works',
    ],
    ELECTRICAL: [
        'Internal Wiring & Terminations',
        'High Side - Panel Erection & Commissioning',
        'Transformer & Switchgear',
        'Low Voltage Works',
    ],
    GYPSUM: ['Drywall Partition', 'False Ceiling', 'Gypsum Punning', 'Decorative Gypsum Works'],
    HVAC: [
        'VRV Works',
        'Duct Fabrication & Erection',
        'DX Works',
        'Ducting Insulation',
        'AHU Erection & Commissioning',
    ],
    PLUMBING: [
        'Internal Plumbing',
        'External Plumbing - High Rise',
        'Fixtures Installation',
        'Pumps Erection & Commissioning',
    ],
    SHUTTERING_CARPENTER: [
        'Aluminium Formwork',
        'Steel Formwork',
        'Plywood Formwork',
        'Fabric Formwork',
        'Timber Formwork',
        'Plastic Formwork',
    ],
}

export const JobType = [
    { label: 'Select Job Type', value: 'none' },
    { label: 'Carpenter', value: 'CARPENTER' },
    { label: 'Bar Bender', value: 'BAR_BENDER' },
    { label: 'General Helper', value: 'GENERAL_HELPER' },
    { label: 'Aluminium Fabricator', value: 'ALUMINIUM_FABRICATOR' },
    { label: 'Welder - Fitter', value: 'WELDER_FITTER' },
    { label: 'Painter', value: 'PAINTER' },
    { label: 'Mason', value: 'MASON' },
    { label: 'Stone/Tile/Marble Layer', value: 'STONE_TILE_MARBLE_LAYER' },
    { label: 'Electrical', value: 'ELECTRICAL' },
    { label: 'Gypsum', value: 'GYPSUM' },
    { label: 'HVAC', value: 'HVAC' },
    { label: 'Plumbing', value: 'PLUMBING' },
    { label: 'Shuttering Carpenter', value: 'SHUTTERING_CARPENTER' },
]

export const ShiftTime = [
    {
        label: 'Select Shift Time',
        value: 'none',
    },
    {
        label: '9am-6pm',
        value: '9am-6pm',
    },
    {
        label: '6pm-12am',
        value: '6pm-12am',
    },
    {
        label: 'Other',
        value: 'other',
    },
]

export const StatesOptions = [
    {
        label: 'Andaman and Nicobar Islands',
        value: 'andaman and nicobar islands',
    },
    {
        label: 'Andhra Pradesh',
        value: 'andhra pradesh',
    },
    {
        label: 'Arunachal Pradesh',
        value: 'arunachal pradesh',
    },
    {
        label: 'Assam',
        value: 'assam',
    },
    {
        label: 'Bihar',
        value: 'bihar',
    },
    {
        label: 'Chandigarh',
        value: 'chandigarh',
    },
    {
        label: 'Chhattisgarh',
        value: 'chhattisgarh',
    },
    {
        label: 'Dadra and Nagar Haveli',
        value: 'dadra and nagar haveli',
    },
    {
        label: 'Daman and Diu',
        value: 'daman and diu',
    },
    {
        label: 'Delhi',
        value: 'delhi',
    },
    {
        label: 'Goa',
        value: 'goa',
    },
    {
        label: 'Gujarat',
        value: 'gujarat',
    },
    {
        label: 'Haryana',
        value: 'haryana',
    },
    {
        label: 'Himachal Pradesh',
        value: 'himachal pradesh',
    },
    {
        label: 'Jammu and Kashmir',
        value: 'jammu and kashmir',
    },
    {
        label: 'Jharkhand',
        value: 'jharkhand',
    },
    {
        label: 'Karnataka',
        value: 'karnataka',
    },
    {
        label: 'Kerala',
        value: 'kerala',
    },
    {
        label: 'Lakshadweep',
        value: 'lakshadweep',
    },
    {
        label: 'Madhya Pradesh',
        value: 'madhya pradesh',
    },
    {
        label: 'Maharashtra',
        value: 'maharashtra',
    },
    {
        label: 'Manipur',
        value: 'manipur',
    },
    {
        label: 'Meghalaya',
        value: 'meghalaya',
    },
    {
        label: 'Mizoram',
        value: 'mizoram',
    },
    {
        label: 'Nagaland',
        value: 'nagaland',
    },
    {
        label: 'Odisha',
        value: 'odisha',
    },
    {
        label: 'Puducherry',
        value: 'puducherry',
    },
    {
        label: 'Punjab',
        value: 'punjab',
    },
    {
        label: 'Rajasthan',
        value: 'rajasthan',
    },
    {
        label: 'Sikkim',
        value: 'sikkim',
    },
    {
        label: 'Tamil Nadu',
        value: 'tamil nadu',
    },
    {
        label: 'Telangana',
        value: 'telangana',
    },
    {
        label: 'Tripura',
        value: 'tripura',
    },
    {
        label: 'Uttar Pradesh',
        value: 'uttar pradesh',
    },
    {
        label: 'Uttarakhand',
        value: 'uttarakhand',
    },
    {
        label: 'West Bengal',
        value: 'west bengal',
    },
]

export const CitiesOptions = {
    none: [],
    'andaman and nicobar islands': [
        {
            id: '334',
            label: 'Port Blair',
            value: 'port blair',
        },
    ],
    'andhra pradesh': [
        {
            id: '18',
            label: 'Visakhapatnam',
            value: 'visakhapatnam',
        },
        {
            id: '41',
            label: 'Vijayawada',
            value: 'vijayawada',
        },
        {
            id: '61',
            label: 'Guntur',
            value: 'guntur',
        },
        {
            id: '81',
            label: 'Nellore',
            value: 'nellore',
        },
        {
            id: '93',
            label: 'Kurnool',
            value: 'kurnool',
        },
        {
            id: '95',
            label: 'Rajahmundry',
            value: 'rajahmundry',
        },
        {
            id: '113',
            label: 'Kakinada',
            value: 'kakinada',
        },
        {
            id: '124',
            label: 'Tirupati',
            value: 'tirupati',
        },
        {
            id: '136',
            label: 'Anantapur',
            value: 'anantapur',
        },
        {
            id: '145',
            label: 'Kadapa',
            value: 'kadapa',
        },
        {
            id: '149',
            label: 'Vizianagaram',
            value: 'vizianagaram',
        },
        {
            id: '161',
            label: 'Eluru',
            value: 'eluru',
        },
        {
            id: '167',
            label: 'Ongole',
            value: 'ongole',
        },
        {
            id: '168',
            label: 'Nandyal',
            value: 'nandyal',
        },
        {
            id: '195',
            label: 'Machilipatnam',
            value: 'machilipatnam',
        },
        {
            id: '202',
            label: 'Adoni',
            value: 'adoni',
        },
        {
            id: '205',
            label: 'Tenali',
            value: 'tenali',
        },
        {
            id: '219',
            label: 'Chittoor',
            value: 'chittoor',
        },
        {
            id: '223',
            label: 'Hindupur',
            value: 'hindupur',
        },
        {
            id: '228',
            label: 'Proddatur',
            value: 'proddatur',
        },
        {
            id: '243',
            label: 'Bhimavaram',
            value: 'bhimavaram',
        },
        {
            id: '250',
            label: 'Madanapalle',
            value: 'madanapalle',
        },
        {
            id: '259',
            label: 'Guntakal',
            value: 'guntakal',
        },
        {
            id: '269',
            label: 'Dharmavaram',
            value: 'dharmavaram',
        },
        {
            id: '274',
            label: 'Gudivada',
            value: 'gudivada',
        },
        {
            id: '277',
            label: 'Srikakulam',
            value: 'srikakulam',
        },
        {
            id: '282',
            label: 'Narasaraopet',
            value: 'narasaraopet',
        },
        {
            id: '303',
            label: 'Rajampet',
            value: 'rajampet',
        },
        {
            id: '306',
            label: 'Tadpatri',
            value: 'tadpatri',
        },
        {
            id: '318',
            label: 'Tadepalligudem',
            value: 'tadepalligudem',
        },
        {
            id: '327',
            label: 'Chilakaluripet',
            value: 'chilakaluripet',
        },
        {
            id: '350',
            label: 'Yemmiganur',
            value: 'yemmiganur',
        },
        {
            id: '365',
            label: 'Kadiri',
            value: 'kadiri',
        },
        {
            id: '378',
            label: 'Chirala',
            value: 'chirala',
        },
        {
            id: '382',
            label: 'Anakapalle',
            value: 'anakapalle',
        },
        {
            id: '393',
            label: 'Kavali',
            value: 'kavali',
        },
        {
            id: '414',
            label: 'Palacole',
            value: 'palacole',
        },
        {
            id: '416',
            label: 'Sullurpeta',
            value: 'sullurpeta',
        },
        {
            id: '437',
            label: 'Tanuku',
            value: 'tanuku',
        },
        {
            id: '438',
            label: 'Rayachoti',
            value: 'rayachoti',
        },
        {
            id: '444',
            label: 'Srikalahasti',
            value: 'srikalahasti',
        },
        {
            id: '446',
            label: 'Bapatla',
            value: 'bapatla',
        },
        {
            id: '488',
            label: 'Naidupet',
            value: 'naidupet',
        },
        {
            id: '497',
            label: 'Nagari',
            value: 'nagari',
        },
        {
            id: '515',
            label: 'Gudur',
            value: 'gudur',
        },
        {
            id: '521',
            label: 'Vinukonda',
            value: 'vinukonda',
        },
        {
            id: '527',
            label: 'Narasapuram',
            value: 'narasapuram',
        },
        {
            id: '528',
            label: 'Nuzvid',
            value: 'nuzvid',
        },
        {
            id: '531',
            label: 'Markapur',
            value: 'markapur',
        },
        {
            id: '540',
            label: 'Ponnur',
            value: 'ponnur',
        },
        {
            id: '544',
            label: 'Kandukur',
            value: 'kandukur',
        },
        {
            id: '550',
            label: 'Bobbili',
            value: 'bobbili',
        },
        {
            id: '570',
            label: 'Rayadurg',
            value: 'rayadurg',
        },
        {
            id: '579',
            label: 'Samalkot',
            value: 'samalkot',
        },
        {
            id: '580',
            label: 'Jaggaiahpet',
            value: 'jaggaiahpet',
        },
        {
            id: '582',
            label: 'Tuni',
            value: 'tuni',
        },
        {
            id: '585',
            label: 'Amalapuram',
            value: 'amalapuram',
        },
        {
            id: '593',
            label: 'Bheemunipatnam',
            value: 'bheemunipatnam',
        },
        {
            id: '599',
            label: 'Venkatagiri',
            value: 'venkatagiri',
        },
        {
            id: '602',
            label: 'Sattenapalle',
            value: 'sattenapalle',
        },
        {
            id: '615',
            label: 'Pithapuram',
            value: 'pithapuram',
        },
        {
            id: '620',
            label: 'Palasa Kasibugga',
            value: 'palasa kasibugga',
        },
        {
            id: '625',
            label: 'Parvathipuram',
            value: 'parvathipuram',
        },
        {
            id: '630',
            label: 'Macherla',
            value: 'macherla',
        },
        {
            id: '637',
            label: 'Gooty',
            value: 'gooty',
        },
        {
            id: '638',
            label: 'Salur',
            value: 'salur',
        },
        {
            id: '647',
            label: 'Mandapeta',
            value: 'mandapeta',
        },
        {
            id: '662',
            label: 'Jammalamadugu',
            value: 'jammalamadugu',
        },
        {
            id: '669',
            label: 'Peddapuram',
            value: 'peddapuram',
        },
        {
            id: '682',
            label: 'Punganur',
            value: 'punganur',
        },
        {
            id: '691',
            label: 'Nidadavole',
            value: 'nidadavole',
        },
        {
            id: '702',
            label: 'Repalle',
            value: 'repalle',
        },
        {
            id: '719',
            label: 'Ramachandrapuram',
            value: 'ramachandrapuram',
        },
        {
            id: '738',
            label: 'Kovvur',
            value: 'kovvur',
        },
        {
            id: '760',
            label: 'Tiruvuru',
            value: 'tiruvuru',
        },
        {
            id: '796',
            label: 'Uravakonda',
            value: 'uravakonda',
        },
        {
            id: '830',
            label: 'Narsipatnam',
            value: 'narsipatnam',
        },
        {
            id: '855',
            label: 'Yerraguntla',
            value: 'yerraguntla',
        },
        {
            id: '916',
            label: 'Pedana',
            value: 'pedana',
        },
        {
            id: '920',
            label: 'Puttur',
            value: 'puttur',
        },
        {
            id: '1055',
            label: 'Renigunta',
            value: 'renigunta',
        },
        {
            id: '1068',
            label: 'Rajam',
            value: 'rajam',
        },
        {
            id: '1074',
            label: 'Srisailam Project (Right Flank Colony) Townshi',
            value: 'srisailam project (right flank colony) township',
        },
    ],
    'arunachal pradesh': [
        {
            id: '789',
            label: 'Naharlagun',
            value: 'naharlagun',
        },
        {
            id: '1122',
            label: 'Pasighat',
            value: 'pasighat',
        },
    ],
    assam: [
        {
            id: '43',
            label: 'Guwahati',
            value: 'guwahati',
        },
        {
            id: '185',
            label: 'Silchar',
            value: 'silchar',
        },
        {
            id: '245',
            label: 'Dibrugarh',
            value: 'dibrugarh',
        },
        {
            id: '281',
            label: 'Nagaon',
            value: 'nagaon',
        },
        {
            id: '337',
            label: 'Tinsukia',
            value: 'tinsukia',
        },
        {
            id: '441',
            label: 'Jorhat',
            value: 'jorhat',
        },
        {
            id: '465',
            label: 'Bongaigaon City',
            value: 'bongaigaon city',
        },
        {
            id: '492',
            label: 'Dhubri',
            value: 'dhubri',
        },
        {
            id: '507',
            label: 'Diphu',
            value: 'diphu',
        },
        {
            id: '520',
            label: 'North Lakhimpur',
            value: 'north lakhimpur',
        },
        {
            id: '529',
            label: 'Tezpur',
            value: 'tezpur',
        },
        {
            id: '548',
            label: 'Karimganj',
            value: 'karimganj',
        },
        {
            id: '575',
            label: 'Sibsagar',
            value: 'sibsagar',
        },
        {
            id: '581',
            label: 'Goalpara',
            value: 'goalpara',
        },
        {
            id: '700',
            label: 'Barpeta',
            value: 'barpeta',
        },
        {
            id: '775',
            label: 'Lanka',
            value: 'lanka',
        },
        {
            id: '888',
            label: 'Lumding',
            value: 'lumding',
        },
        {
            id: '934',
            label: 'Mankachar',
            value: 'mankachar',
        },
        {
            id: '954',
            label: 'Nalbari',
            value: 'nalbari',
        },
        {
            id: '1025',
            label: 'Rangia',
            value: 'rangia',
        },
        {
            id: '1051',
            label: 'Margherita',
            value: 'margherita',
        },
        {
            id: '1054',
            label: 'Mangaldoi',
            value: 'mangaldoi',
        },
        {
            id: '1106',
            label: 'Silapathar',
            value: 'silapathar',
        },
        {
            id: '1157',
            label: 'Mariani',
            value: 'mariani',
        },
        {
            id: '1169',
            label: 'Marigaon',
            value: 'marigaon',
        },
        {
            id: '1221',
            label: 'Dispur',
            value: 'dispur',
        },
    ],
    bihar: [
        {
            id: '14',
            label: 'Patna',
            value: 'patna',
        },
        {
            id: '88',
            label: 'Gaya',
            value: 'gaya',
        },
        {
            id: '98',
            label: 'Bhagalpur',
            value: 'bhagalpur',
        },
        {
            id: '105',
            label: 'Muzaffarpur',
            value: 'muzaffarpur',
        },
        {
            id: '120',
            label: 'Darbhanga',
            value: 'darbhanga',
        },
        {
            id: '137',
            label: 'Arrah',
            value: 'arrah',
        },
        {
            id: '142',
            label: 'Begusarai',
            value: 'begusarai',
        },
        {
            id: '144',
            label: 'Chhapra',
            value: 'chhapra',
        },
        {
            id: '150',
            label: 'Katihar',
            value: 'katihar',
        },
        {
            id: '162',
            label: 'Munger',
            value: 'munger',
        },
        {
            id: '174',
            label: 'Purnia',
            value: 'purnia',
        },
        {
            id: '217',
            label: 'Saharsa',
            value: 'saharsa',
        },
        {
            id: '232',
            label: 'Sasaram',
            value: 'sasaram',
        },
        {
            id: '233',
            label: 'Hajipur',
            value: 'hajipur',
        },
        {
            id: '249',
            label: 'Dehri-on-Sone',
            value: 'dehri-on-sone',
        },
        {
            id: '253',
            label: 'Bettiah',
            value: 'bettiah',
        },
        {
            id: '263',
            label: 'Motihari',
            value: 'motihari',
        },
        {
            id: '291',
            label: 'Bagaha',
            value: 'bagaha',
        },
        {
            id: '302',
            label: 'Siwan',
            value: 'siwan',
        },
        {
            id: '309',
            label: 'Kishanganj',
            value: 'kishanganj',
        },
        {
            id: '315',
            label: 'Jamalpur',
            value: 'jamalpur',
        },
        {
            id: '320',
            label: 'Buxar',
            value: 'buxar',
        },
        {
            id: '322',
            label: 'Jehanabad',
            value: 'jehanabad',
        },
        {
            id: '328',
            label: 'Aurangabad',
            value: 'aurangabad',
        },
        {
            id: '335',
            label: 'Lakhisarai',
            value: 'lakhisarai',
        },
        {
            id: '341',
            label: 'Nawada',
            value: 'nawada',
        },
        {
            id: '376',
            label: 'Jamui',
            value: 'jamui',
        },
        {
            id: '377',
            label: 'Sitamarhi',
            value: 'sitamarhi',
        },
        {
            id: '405',
            label: 'Araria',
            value: 'araria',
        },
        {
            id: '464',
            label: 'Gopalganj',
            value: 'gopalganj',
        },
        {
            id: '476',
            label: 'Madhubani',
            value: 'madhubani',
        },
        {
            id: '493',
            label: 'Masaurhi',
            value: 'masaurhi',
        },
        {
            id: '501',
            label: 'Samastipur',
            value: 'samastipur',
        },
        {
            id: '551',
            label: 'Mokameh',
            value: 'mokameh',
        },
        {
            id: '571',
            label: 'Supaul',
            value: 'supaul',
        },
        {
            id: '578',
            label: 'Dumraon',
            value: 'dumraon',
        },
        {
            id: '598',
            label: 'Arwal',
            value: 'arwal',
        },
        {
            id: '611',
            label: 'Forbesganj',
            value: 'forbesganj',
        },
        {
            id: '613',
            label: 'BhabUrban Agglomeration',
            value: 'bhaburban agglomeration',
        },
        {
            id: '628',
            label: 'Narkatiaganj',
            value: 'narkatiaganj',
        },
        {
            id: '633',
            label: 'Naugachhia',
            value: 'naugachhia',
        },
        {
            id: '672',
            label: 'Madhepura',
            value: 'madhepura',
        },
        {
            id: '694',
            label: 'Sheikhpura',
            value: 'sheikhpura',
        },
        {
            id: '712',
            label: 'Sultanganj',
            value: 'sultanganj',
        },
        {
            id: '715',
            label: 'Raxaul Bazar',
            value: 'raxaul bazar',
        },
        {
            id: '749',
            label: 'Ramnagar',
            value: 'ramnagar',
        },
        {
            id: '766',
            label: 'Mahnar Bazar',
            value: 'mahnar bazar',
        },
        {
            id: '821',
            label: 'Warisaliganj',
            value: 'warisaliganj',
        },
        {
            id: '822',
            label: 'Revelganj',
            value: 'revelganj',
        },
        {
            id: '832',
            label: 'Rajgir',
            value: 'rajgir',
        },
        {
            id: '838',
            label: 'Sonepur',
            value: 'sonepur',
        },
        {
            id: '857',
            label: 'Sherghati',
            value: 'sherghati',
        },
        {
            id: '887',
            label: 'Sugauli',
            value: 'sugauli',
        },
        {
            id: '905',
            label: 'Makhdumpur',
            value: 'makhdumpur',
        },
        {
            id: '906',
            label: 'Maner',
            value: 'maner',
        },
        {
            id: '969',
            label: 'Rosera',
            value: 'rosera',
        },
        {
            id: '974',
            label: 'Nokha',
            value: 'nokha',
        },
        {
            id: '1009',
            label: 'Piro',
            value: 'piro',
        },
        {
            id: '1030',
            label: 'Rafiganj',
            value: 'rafiganj',
        },
        {
            id: '1039',
            label: 'Marhaura',
            value: 'marhaura',
        },
        {
            id: '1065',
            label: 'Mirganj',
            value: 'mirganj',
        },
        {
            id: '1081',
            label: 'Lalganj',
            value: 'lalganj',
        },
        {
            id: '1087',
            label: 'Murliganj',
            value: 'murliganj',
        },
        {
            id: '1123',
            label: 'Motipur',
            value: 'motipur',
        },
        {
            id: '1134',
            label: 'Manihari',
            value: 'manihari',
        },
        {
            id: '1148',
            label: 'Sheohar',
            value: 'sheohar',
        },
        {
            id: '1165',
            label: 'Maharajganj',
            value: 'maharajganj',
        },
        {
            id: '1186',
            label: 'Silao',
            value: 'silao',
        },
        {
            id: '1205',
            label: 'Barh',
            value: 'barh',
        },
        {
            id: '1214',
            label: 'Asarganj',
            value: 'asarganj',
        },
    ],
    chandigarh: [
        {
            id: '44',
            label: 'Chandigarh',
            value: 'chandigarh',
        },
    ],
    chhattisgarh: [
        {
            id: '36',
            label: 'Raipur',
            value: 'raipur',
        },
        {
            id: '66',
            label: 'Bhilai Nagar',
            value: 'bhilai nagar',
        },
        {
            id: '101',
            label: 'Korba',
            value: 'korba',
        },
        {
            id: '109',
            label: 'Bilaspur',
            value: 'bilaspur',
        },
        {
            id: '131',
            label: 'Durg',
            value: 'durg',
        },
        {
            id: '240',
            label: 'Rajnandgaon',
            value: 'rajnandgaon',
        },
        {
            id: '262',
            label: 'Jagdalpur',
            value: 'jagdalpur',
        },
        {
            id: '283',
            label: 'Raigarh',
            value: 'raigarh',
        },
        {
            id: '286',
            label: 'Ambikapur',
            value: 'ambikapur',
        },
        {
            id: '383',
            label: 'Mahasamund',
            value: 'mahasamund',
        },
        {
            id: '394',
            label: 'Dhamtari',
            value: 'dhamtari',
        },
        {
            id: '455',
            label: 'Chirmiri',
            value: 'chirmiri',
        },
        {
            id: '543',
            label: 'Bhatapara',
            value: 'bhatapara',
        },
        {
            id: '681',
            label: 'Dalli-Rajhara',
            value: 'dalli-rajhara',
        },
        {
            id: '730',
            label: 'Naila Janjgir',
            value: 'naila janjgir',
        },
        {
            id: '865',
            label: 'Tilda Newra',
            value: 'tilda newra',
        },
        {
            id: '882',
            label: 'Mungeli',
            value: 'mungeli',
        },
        {
            id: '900',
            label: 'Manendragarh',
            value: 'manendragarh',
        },
        {
            id: '1184',
            label: 'Sakti',
            value: 'sakti',
        },
    ],
    'dadra and nagar haveli': [
        {
            id: '1129',
            label: 'Silvassa',
            value: 'silvassa',
        },
    ],
    'daman and diu': [
        {
            id: 'Daman and Diu',
            label: 'Daman and Diu',
            value: 'daman and diu',
        },
    ],
    delhi: [
        {
            id: '2',
            label: 'Delhi',
            value: 'delhi',
        },
        {
            id: '143',
            label: 'New Delhi',
            value: 'new delhi',
        },
    ],
    goa: [
        {
            id: '316',
            label: 'Marmagao',
            value: 'marmagao',
        },
        {
            id: '336',
            label: 'Panaji',
            value: 'panaji',
        },
        {
            id: '354',
            label: 'Margao',
            value: 'margao',
        },
        {
            id: '731',
            label: 'Mapusa',
            value: 'mapusa',
        },
    ],
    gujarat: [
        {
            id: '4',
            label: 'Ahmedabad',
            value: 'ahmedabad',
        },
        {
            id: '10',
            label: 'Surat',
            value: 'surat',
        },
        {
            id: '19',
            label: 'Vadodara',
            value: 'vadodara',
        },
        {
            id: '22',
            label: 'Rajkot',
            value: 'rajkot',
        },
        {
            id: '70',
            label: 'Bhavnagar',
            value: 'bhavnagar',
        },
        {
            id: '75',
            label: 'Jamnagar',
            value: 'jamnagar',
        },
        {
            id: '158',
            label: 'Nadiad',
            value: 'nadiad',
        },
        {
            id: '171',
            label: 'Porbandar',
            value: 'porbandar',
        },
        {
            id: '173',
            label: 'Anand',
            value: 'anand',
        },
        {
            id: '177',
            label: 'Morvi',
            value: 'morvi',
        },
        {
            id: '184',
            label: 'Mahesana',
            value: 'mahesana',
        },
        {
            id: '198',
            label: 'Bharuch',
            value: 'bharuch',
        },
        {
            id: '209',
            label: 'Navsari',
            value: 'navsari',
        },
        {
            id: '220',
            label: 'Veraval',
            value: 'veraval',
        },
        {
            id: '234',
            label: 'Bhuj',
            value: 'bhuj',
        },
        {
            id: '241',
            label: 'Godhra',
            value: 'godhra',
        },
        {
            id: '258',
            label: 'Palanpur',
            value: 'palanpur',
        },
        {
            id: '285',
            label: 'Valsad',
            value: 'valsad',
        },
        {
            id: '290',
            label: 'Patan',
            value: 'patan',
        },
        {
            id: '295',
            label: 'Deesa',
            value: 'deesa',
        },
        {
            id: '313',
            label: 'Amreli',
            value: 'amreli',
        },
        {
            id: '379',
            label: 'Anjar',
            value: 'anjar',
        },
        {
            id: '386',
            label: 'Dhoraji',
            value: 'dhoraji',
        },
        {
            id: '390',
            label: 'Khambhat',
            value: 'khambhat',
        },
        {
            id: '397',
            label: 'Mahuva',
            value: 'mahuva',
        },
        {
            id: '415',
            label: 'Keshod',
            value: 'keshod',
        },
        {
            id: '417',
            label: 'Wadhwan',
            value: 'wadhwan',
        },
        {
            id: '425',
            label: 'Ankleshwar',
            value: 'ankleshwar',
        },
        {
            id: '426',
            label: 'Savarkundla',
            value: 'savarkundla',
        },
        {
            id: '430',
            label: 'Kadi',
            value: 'kadi',
        },
        {
            id: '494',
            label: 'Visnagar',
            value: 'visnagar',
        },
        {
            id: '526',
            label: 'Upleta',
            value: 'upleta',
        },
        {
            id: '530',
            label: 'Una',
            value: 'una',
        },
        {
            id: '534',
            label: 'Sidhpur',
            value: 'sidhpur',
        },
        {
            id: '546',
            label: 'Unjha',
            value: 'unjha',
        },
        {
            id: '554',
            label: 'Mangrol',
            value: 'mangrol',
        },
        {
            id: '561',
            label: 'Viramgam',
            value: 'viramgam',
        },
        {
            id: '569',
            label: 'Modasa',
            value: 'modasa',
        },
        {
            id: '597',
            label: 'Palitana',
            value: 'palitana',
        },
        {
            id: '606',
            label: 'Petlad',
            value: 'petlad',
        },
        {
            id: '629',
            label: 'Kapadvanj',
            value: 'kapadvanj',
        },
        {
            id: '655',
            label: 'Sihor',
            value: 'sihor',
        },
        {
            id: '689',
            label: 'Wankaner',
            value: 'wankaner',
        },
        {
            id: '699',
            label: 'Limbdi',
            value: 'limbdi',
        },
        {
            id: '705',
            label: 'Mandvi',
            value: 'mandvi',
        },
        {
            id: '706',
            label: 'Thangadh',
            value: 'thangadh',
        },
        {
            id: '737',
            label: 'Vyara',
            value: 'vyara',
        },
        {
            id: '741',
            label: 'Padra',
            value: 'padra',
        },
        {
            id: '772',
            label: 'Lunawada',
            value: 'lunawada',
        },
        {
            id: '806',
            label: 'Rajpipla',
            value: 'rajpipla',
        },
        {
            id: '819',
            label: 'Vapi',
            value: 'vapi',
        },
        {
            id: '829',
            label: 'Umreth',
            value: 'umreth',
        },
        {
            id: '861',
            label: 'Sanand',
            value: 'sanand',
        },
        {
            id: '862',
            label: 'Rajula',
            value: 'rajula',
        },
        {
            id: '872',
            label: 'Radhanpur',
            value: 'radhanpur',
        },
        {
            id: '899',
            label: 'Mahemdabad',
            value: 'mahemdabad',
        },
        {
            id: '915',
            label: 'Ranavav',
            value: 'ranavav',
        },
        {
            id: '950',
            label: 'Tharad',
            value: 'tharad',
        },
        {
            id: '951',
            label: 'Mansa',
            value: 'mansa',
        },
        {
            id: '952',
            label: 'Umbergaon',
            value: 'umbergaon',
        },
        {
            id: '955',
            label: 'Talaja',
            value: 'talaja',
        },
        {
            id: '960',
            label: 'Vadnagar',
            value: 'vadnagar',
        },
        {
            id: '965',
            label: 'Manavadar',
            value: 'manavadar',
        },
        {
            id: '979',
            label: 'Salaya',
            value: 'salaya',
        },
        {
            id: '1013',
            label: 'Vijapur',
            value: 'vijapur',
        },
        {
            id: '1020',
            label: 'Pardi',
            value: 'pardi',
        },
        {
            id: '1083',
            label: 'Rapar',
            value: 'rapar',
        },
        {
            id: '1107',
            label: 'Songadh',
            value: 'songadh',
        },
        {
            id: '1151',
            label: 'Lathi',
            value: 'lathi',
        },
        {
            id: '1203',
            label: 'Adalaj',
            value: 'adalaj',
        },
        {
            id: '1206',
            label: 'Chhapra',
            value: 'chhapra',
        },
        {
            id: '1216',
            label: 'Gandhinagar',
            value: 'gandhinagar',
        },
    ],
    haryana: [
        {
            id: '26',
            label: 'Faridabad',
            value: 'faridabad',
        },
        {
            id: '48',
            label: 'Gurgaon',
            value: 'gurgaon',
        },
        {
            id: '117',
            label: 'Hisar',
            value: 'hisar',
        },
        {
            id: '118',
            label: 'Rohtak',
            value: 'rohtak',
        },
        {
            id: '119',
            label: 'Panipat',
            value: 'panipat',
        },
        {
            id: '125',
            label: 'Karnal',
            value: 'karnal',
        },
        {
            id: '152',
            label: 'Sonipat',
            value: 'sonipat',
        },
        {
            id: '159',
            label: 'Yamunanagar',
            value: 'yamunanagar',
        },
        {
            id: '163',
            label: 'Panchkula',
            value: 'panchkula',
        },
        {
            id: '170',
            label: 'Bhiwani',
            value: 'bhiwani',
        },
        {
            id: '194',
            label: 'Bahadurgarh',
            value: 'bahadurgarh',
        },
        {
            id: '203',
            label: 'Jind',
            value: 'jind',
        },
        {
            id: '208',
            label: 'Sirsa',
            value: 'sirsa',
        },
        {
            id: '218',
            label: 'Thanesar',
            value: 'thanesar',
        },
        {
            id: '239',
            label: 'Kaithal',
            value: 'kaithal',
        },
        {
            id: '257',
            label: 'Palwal',
            value: 'palwal',
        },
        {
            id: '330',
            label: 'Rewari',
            value: 'rewari',
        },
        {
            id: '381',
            label: 'Hansi',
            value: 'hansi',
        },
        {
            id: '421',
            label: 'Narnaul',
            value: 'narnaul',
        },
        {
            id: '447',
            label: 'Fatehabad',
            value: 'fatehabad',
        },
        {
            id: '478',
            label: 'Gohana',
            value: 'gohana',
        },
        {
            id: '490',
            label: 'Tohana',
            value: 'tohana',
        },
        {
            id: '498',
            label: 'Narwana',
            value: 'narwana',
        },
        {
            id: '576',
            label: 'Mandi Dabwali',
            value: 'mandi dabwali',
        },
        {
            id: '618',
            label: 'Charkhi Dadri',
            value: 'charkhi dadri',
        },
        {
            id: '768',
            label: 'Shahbad',
            value: 'shahbad',
        },
        {
            id: '837',
            label: 'Pehowa',
            value: 'pehowa',
        },
        {
            id: '912',
            label: 'Samalkha',
            value: 'samalkha',
        },
        {
            id: '917',
            label: 'Pinjore',
            value: 'pinjore',
        },
        {
            id: '933',
            label: 'Ladwa',
            value: 'ladwa',
        },
        {
            id: '964',
            label: 'Sohna',
            value: 'sohna',
        },
        {
            id: '967',
            label: 'Safidon',
            value: 'safidon',
        },
        {
            id: '1003',
            label: 'Taraori',
            value: 'taraori',
        },
        {
            id: '1045',
            label: 'Mahendragarh',
            value: 'mahendragarh',
        },
        {
            id: '1057',
            label: 'Ratia',
            value: 'ratia',
        },
        {
            id: '1159',
            label: 'Rania',
            value: 'rania',
        },
        {
            id: '1215',
            label: 'Sarsod',
            value: 'sarsod',
        },
    ],
    'himachal pradesh': [
        {
            id: '237',
            label: 'Shimla',
            value: 'shimla',
        },
        {
            id: '518',
            label: 'Mandi',
            value: 'mandi',
        },
        {
            id: '818',
            label: 'Solan',
            value: 'solan',
        },
        {
            id: '932',
            label: 'Nahan',
            value: 'nahan',
        },
        {
            id: '1052',
            label: 'Sundarnagar',
            value: 'sundarnagar',
        },
        {
            id: '1073',
            label: 'Palampur',
            value: 'palampur',
        },
        {
            id: '1217',
            label: 'Kullu',
            value: 'kullu',
        },
    ],
    'jammu and kashmir': [
        {
            id: '32',
            label: 'Srinagar',
            value: 'srinagar',
        },
        {
            id: '82',
            label: 'Jammu',
            value: 'jammu',
        },
        {
            id: '201',
            label: 'Baramula',
            value: 'baramula',
        },
        {
            id: '305',
            label: 'Anantnag',
            value: 'anantnag',
        },
        {
            id: '468',
            label: 'Sopore',
            value: 'sopore',
        },
        {
            id: '596',
            label: 'KathUrban Agglomeration',
            value: 'kathurban agglomeration',
        },
        {
            id: '716',
            label: 'Rajauri',
            value: 'rajauri',
        },
        {
            id: '723',
            label: 'Punch',
            value: 'punch',
        },
        {
            id: '799',
            label: 'Udhampur',
            value: 'udhampur',
        },
    ],
    jharkhand: [
        {
            id: '33',
            label: 'Dhanbad',
            value: 'dhanbad',
        },
        {
            id: '51',
            label: 'Ranchi',
            value: 'ranchi',
        },
        {
            id: '65',
            label: 'Jamshedpur',
            value: 'jamshedpur',
        },
        {
            id: '94',
            label: 'Bokaro Steel City',
            value: 'bokaro steel city',
        },
        {
            id: '166',
            label: 'Deoghar',
            value: 'deoghar',
        },
        {
            id: '191',
            label: 'Phusro',
            value: 'phusro',
        },
        {
            id: '192',
            label: 'Adityapur',
            value: 'adityapur',
        },
        {
            id: '242',
            label: 'Hazaribag',
            value: 'hazaribag',
        },
        {
            id: '287',
            label: 'Giridih',
            value: 'giridih',
        },
        {
            id: '298',
            label: 'Ramgarh',
            value: 'ramgarh',
        },
        {
            id: '373',
            label: 'Jhumri Tilaiya',
            value: 'jhumri tilaiya',
        },
        {
            id: '385',
            label: 'Saunda',
            value: 'saunda',
        },
        {
            id: '400',
            label: 'Sahibganj',
            value: 'sahibganj',
        },
        {
            id: '408',
            label: 'Medininagar (Daltonganj)',
            value: 'medininagar (daltonganj)',
        },
        {
            id: '454',
            label: 'Chaibasa',
            value: 'chaibasa',
        },
        {
            id: '619',
            label: 'Chatra',
            value: 'chatra',
        },
        {
            id: '642',
            label: 'Gumia',
            value: 'gumia',
        },
        {
            id: '648',
            label: 'Dumka',
            value: 'dumka',
        },
        {
            id: '651',
            label: 'Madhupur',
            value: 'madhupur',
        },
        {
            id: '670',
            label: 'Chirkunda',
            value: 'chirkunda',
        },
        {
            id: '790',
            label: 'Pakaur',
            value: 'pakaur',
        },
        {
            id: '825',
            label: 'Simdega',
            value: 'simdega',
        },
        {
            id: '826',
            label: 'Musabani',
            value: 'musabani',
        },
        {
            id: '841',
            label: 'Mihijam',
            value: 'mihijam',
        },
        {
            id: '875',
            label: 'Patratu',
            value: 'patratu',
        },
        {
            id: '1049',
            label: 'Lohardaga',
            value: 'lohardaga',
        },
        {
            id: '1119',
            label: 'Tenu dam-cum-Kathhara',
            value: 'tenu dam-cum-kathhara',
        },
    ],
    karnataka: [
        {
            id: '3',
            label: 'Bengaluru',
            value: 'bengaluru',
        },
        {
            id: '45',
            label: 'Hubli-Dharwad',
            value: 'hubli-dharwad',
        },
        {
            id: '83',
            label: 'Belagavi',
            value: 'belagavi',
        },
        {
            id: '85',
            label: 'Mangaluru',
            value: 'mangaluru',
        },
        {
            id: '90',
            label: 'Davanagere',
            value: 'davanagere',
        },
        {
            id: '96',
            label: 'Ballari',
            value: 'ballari',
        },
        {
            id: '104',
            label: 'Mysore',
            value: 'mysore',
        },
        {
            id: '116',
            label: 'Tumkur',
            value: 'tumkur',
        },
        {
            id: '128',
            label: 'Shivamogga',
            value: 'shivamogga',
        },
        {
            id: '164',
            label: 'Raayachuru',
            value: 'raayachuru',
        },
        {
            id: '212',
            label: 'Robertson Pet',
            value: 'robertson pet',
        },
        {
            id: '246',
            label: 'Kolar',
            value: 'kolar',
        },
        {
            id: '248',
            label: 'Mandya',
            value: 'mandya',
        },
        {
            id: '261',
            label: 'Udupi',
            value: 'udupi',
        },
        {
            id: '273',
            label: 'Chikkamagaluru',
            value: 'chikkamagaluru',
        },
        {
            id: '301',
            label: 'Karwar',
            value: 'karwar',
        },
        {
            id: '312',
            label: 'Ranebennuru',
            value: 'ranebennuru',
        },
        {
            id: '364',
            label: 'Ranibennur',
            value: 'ranibennur',
        },
        {
            id: '402',
            label: 'Ramanagaram',
            value: 'ramanagaram',
        },
        {
            id: '403',
            label: 'Gokak',
            value: 'gokak',
        },
        {
            id: '423',
            label: 'Yadgir',
            value: 'yadgir',
        },
        {
            id: '452',
            label: 'Rabkavi Banhatti',
            value: 'rabkavi banhatti',
        },
        {
            id: '473',
            label: 'Shahabad',
            value: 'shahabad',
        },
        {
            id: '481',
            label: 'Sirsi',
            value: 'sirsi',
        },
        {
            id: '511',
            label: 'Sindhnur',
            value: 'sindhnur',
        },
        {
            id: '522',
            label: 'Tiptur',
            value: 'tiptur',
        },
        {
            id: '603',
            label: 'Arsikere',
            value: 'arsikere',
        },
        {
            id: '610',
            label: 'Nanjangud',
            value: 'nanjangud',
        },
        {
            id: '614',
            label: 'Sagara',
            value: 'sagara',
        },
        {
            id: '616',
            label: 'Sira',
            value: 'sira',
        },
        {
            id: '643',
            label: 'Puttur',
            value: 'puttur',
        },
        {
            id: '665',
            label: 'Athni',
            value: 'athni',
        },
        {
            id: '687',
            label: 'Mulbagal',
            value: 'mulbagal',
        },
        {
            id: '692',
            label: 'Surapura',
            value: 'surapura',
        },
        {
            id: '697',
            label: 'Siruguppa',
            value: 'siruguppa',
        },
        {
            id: '703',
            label: 'Mudhol',
            value: 'mudhol',
        },
        {
            id: '722',
            label: 'Sidlaghatta',
            value: 'sidlaghatta',
        },
        {
            id: '744',
            label: 'Shahpur',
            value: 'shahpur',
        },
        {
            id: '752',
            label: 'Saundatti-Yellamma',
            value: 'saundatti-yellamma',
        },
        {
            id: '754',
            label: 'Wadi',
            value: 'wadi',
        },
        {
            id: '764',
            label: 'Manvi',
            value: 'manvi',
        },
        {
            id: '770',
            label: 'Nelamangala',
            value: 'nelamangala',
        },
        {
            id: '778',
            label: 'Lakshmeshwar',
            value: 'lakshmeshwar',
        },
        {
            id: '782',
            label: 'Ramdurg',
            value: 'ramdurg',
        },
        {
            id: '785',
            label: 'Nargund',
            value: 'nargund',
        },
        {
            id: '792',
            label: 'Tarikere',
            value: 'tarikere',
        },
        {
            id: '793',
            label: 'Malavalli',
            value: 'malavalli',
        },
        {
            id: '797',
            label: 'Savanur',
            value: 'savanur',
        },
        {
            id: '802',
            label: 'Lingsugur',
            value: 'lingsugur',
        },
        {
            id: '807',
            label: 'Vijayapura',
            value: 'vijayapura',
        },
        {
            id: '858',
            label: 'Sankeshwara',
            value: 'sankeshwara',
        },
        {
            id: '859',
            label: 'Madikeri',
            value: 'madikeri',
        },
        {
            id: '880',
            label: 'Talikota',
            value: 'talikota',
        },
        {
            id: '883',
            label: 'Sedam',
            value: 'sedam',
        },
        {
            id: '884',
            label: 'Shikaripur',
            value: 'shikaripur',
        },
        {
            id: '897',
            label: 'Mahalingapura',
            value: 'mahalingapura',
        },
        {
            id: '911',
            label: 'Mudalagi',
            value: 'mudalagi',
        },
        {
            id: '944',
            label: 'Muddebihal',
            value: 'muddebihal',
        },
        {
            id: '949',
            label: 'Pavagada',
            value: 'pavagada',
        },
        {
            id: '956',
            label: 'Malur',
            value: 'malur',
        },
        {
            id: '962',
            label: 'Sindhagi',
            value: 'sindhagi',
        },
        {
            id: '963',
            label: 'Sanduru',
            value: 'sanduru',
        },
        {
            id: '977',
            label: 'Afzalpur',
            value: 'afzalpur',
        },
        {
            id: '991',
            label: 'Maddur',
            value: 'maddur',
        },
        {
            id: '995',
            label: 'Madhugiri',
            value: 'madhugiri',
        },
        {
            id: '996',
            label: 'Tekkalakote',
            value: 'tekkalakote',
        },
        {
            id: '1000',
            label: 'Terdal',
            value: 'terdal',
        },
        {
            id: '1010',
            label: 'Mudabidri',
            value: 'mudabidri',
        },
        {
            id: '1028',
            label: 'Magadi',
            value: 'magadi',
        },
        {
            id: '1037',
            label: 'Navalgund',
            value: 'navalgund',
        },
        {
            id: '1043',
            label: 'Shiggaon',
            value: 'shiggaon',
        },
        {
            id: '1059',
            label: 'Shrirangapattana',
            value: 'shrirangapattana',
        },
        {
            id: '1075',
            label: 'Sindagi',
            value: 'sindagi',
        },
        {
            id: '1080',
            label: 'Sakaleshapura',
            value: 'sakaleshapura',
        },
        {
            id: '1086',
            label: 'Srinivaspur',
            value: 'srinivaspur',
        },
        {
            id: '1138',
            label: 'Ron',
            value: 'ron',
        },
        {
            id: '1180',
            label: 'Mundargi',
            value: 'mundargi',
        },
        {
            id: '1185',
            label: 'Sadalagi',
            value: 'sadalagi',
        },
        {
            id: '1201',
            label: 'Piriyapatna',
            value: 'piriyapatna',
        },
        {
            id: '1211',
            label: 'Adyar',
            value: 'adyar',
        },
    ],
    kerala: [
        {
            id: '58',
            label: 'Thiruvananthapuram',
            value: 'thiruvananthapuram',
        },
        {
            id: '68',
            label: 'Kochi',
            value: 'kochi',
        },
        {
            id: '91',
            label: 'Kozhikode',
            value: 'kozhikode',
        },
        {
            id: '107',
            label: 'Kollam',
            value: 'kollam',
        },
        {
            id: '111',
            label: 'Thrissur',
            value: 'thrissur',
        },
        {
            id: '172',
            label: 'Palakkad',
            value: 'palakkad',
        },
        {
            id: '193',
            label: 'Alappuzha',
            value: 'alappuzha',
        },
        {
            id: '329',
            label: 'Malappuram',
            value: 'malappuram',
        },
        {
            id: '375',
            label: 'Ponnani',
            value: 'ponnani',
        },
        {
            id: '419',
            label: 'Vatakara',
            value: 'vatakara',
        },
        {
            id: '429',
            label: 'Kanhangad',
            value: 'kanhangad',
        },
        {
            id: '435',
            label: 'Taliparamba',
            value: 'taliparamba',
        },
        {
            id: '440',
            label: 'Koyilandy',
            value: 'koyilandy',
        },
        {
            id: '445',
            label: 'Neyyattinkara',
            value: 'neyyattinkara',
        },
        {
            id: '458',
            label: 'Kayamkulam',
            value: 'kayamkulam',
        },
        {
            id: '519',
            label: 'Nedumangad',
            value: 'nedumangad',
        },
        {
            id: '549',
            label: 'Kannur',
            value: 'kannur',
        },
        {
            id: '558',
            label: 'Tirur',
            value: 'tirur',
        },
        {
            id: '564',
            label: 'Kottayam',
            value: 'kottayam',
        },
        {
            id: '568',
            label: 'Kasaragod',
            value: 'kasaragod',
        },
        {
            id: '572',
            label: 'Kunnamkulam',
            value: 'kunnamkulam',
        },
        {
            id: '577',
            label: 'Ottappalam',
            value: 'ottappalam',
        },
        {
            id: '588',
            label: 'Thiruvalla',
            value: 'thiruvalla',
        },
        {
            id: '595',
            label: 'Thodupuzha',
            value: 'thodupuzha',
        },
        {
            id: '627',
            label: 'Chalakudy',
            value: 'chalakudy',
        },
        {
            id: '646',
            label: 'Changanassery',
            value: 'changanassery',
        },
        {
            id: '653',
            label: 'Punalur',
            value: 'punalur',
        },
        {
            id: '659',
            label: 'Nilambur',
            value: 'nilambur',
        },
        {
            id: '666',
            label: 'Cherthala',
            value: 'cherthala',
        },
        {
            id: '678',
            label: 'Perinthalmanna',
            value: 'perinthalmanna',
        },
        {
            id: '683',
            label: 'Mattannur',
            value: 'mattannur',
        },
        {
            id: '709',
            label: 'Shoranur',
            value: 'shoranur',
        },
        {
            id: '727',
            label: 'Varkala',
            value: 'varkala',
        },
        {
            id: '747',
            label: 'Paravoor',
            value: 'paravoor',
        },
        {
            id: '753',
            label: 'Pathanamthitta',
            value: 'pathanamthitta',
        },
        {
            id: '762',
            label: 'Peringathur',
            value: 'peringathur',
        },
        {
            id: '767',
            label: 'Attingal',
            value: 'attingal',
        },
        {
            id: '827',
            label: 'Kodungallur',
            value: 'kodungallur',
        },
        {
            id: '839',
            label: 'Pappinisseri',
            value: 'pappinisseri',
        },
        {
            id: '867',
            label: 'Chittur-Thathamangalam',
            value: 'chittur-thathamangalam',
        },
        {
            id: '925',
            label: 'Muvattupuzha',
            value: 'muvattupuzha',
        },
        {
            id: '929',
            label: 'Adoor',
            value: 'adoor',
        },
        {
            id: '939',
            label: 'Mavelikkara',
            value: 'mavelikkara',
        },
        {
            id: '953',
            label: 'Mavoor',
            value: 'mavoor',
        },
        {
            id: '990',
            label: 'Perumbavoor',
            value: 'perumbavoor',
        },
        {
            id: '1077',
            label: 'Vaikom',
            value: 'vaikom',
        },
        {
            id: '1098',
            label: 'Palai',
            value: 'palai',
        },
        {
            id: '1164',
            label: 'Panniyannur',
            value: 'panniyannur',
        },
        {
            id: '1176',
            label: 'Guruvayoor',
            value: 'guruvayoor',
        },
        {
            id: '1195',
            label: 'Puthuppally',
            value: 'puthuppally',
        },
        {
            id: '1207',
            label: 'Panamattom',
            value: 'panamattom',
        },
    ],
    lakshadweep: [],
    'madhya pradesh': [
        {
            id: '15',
            label: 'Indore',
            value: 'indore',
        },
        {
            id: '17',
            label: 'Bhopal',
            value: 'bhopal',
        },
        {
            id: '39',
            label: 'Jabalpur',
            value: 'jabalpur',
        },
        {
            id: '40',
            label: 'Gwalior',
            value: 'gwalior',
        },
        {
            id: '76',
            label: 'Ujjain',
            value: 'ujjain',
        },
        {
            id: '115',
            label: 'Sagar',
            value: 'sagar',
        },
        {
            id: '129',
            label: 'Ratlam',
            value: 'ratlam',
        },
        {
            id: '148',
            label: 'Satna',
            value: 'satna',
        },
        {
            id: '155',
            label: 'Murwara (Katni)',
            value: 'murwara (katni)',
        },
        {
            id: '169',
            label: 'Morena',
            value: 'morena',
        },
        {
            id: '182',
            label: 'Singrauli',
            value: 'singrauli',
        },
        {
            id: '187',
            label: 'Rewa',
            value: 'rewa',
        },
        {
            id: '216',
            label: 'Vidisha',
            value: 'vidisha',
        },
        {
            id: '226',
            label: 'Ganjbasoda',
            value: 'ganjbasoda',
        },
        {
            id: '235',
            label: 'Shivpuri',
            value: 'shivpuri',
        },
        {
            id: '244',
            label: 'Mandsaur',
            value: 'mandsaur',
        },
        {
            id: '256',
            label: 'Neemuch',
            value: 'neemuch',
        },
        {
            id: '333',
            label: 'Nagda',
            value: 'nagda',
        },
        {
            id: '338',
            label: 'Itarsi',
            value: 'itarsi',
        },
        {
            id: '352',
            label: 'Sarni',
            value: 'sarni',
        },
        {
            id: '356',
            label: 'Sehore',
            value: 'sehore',
        },
        {
            id: '357',
            label: 'Mhow Cantonment',
            value: 'mhow cantonment',
        },
        {
            id: '363',
            label: 'Seoni',
            value: 'seoni',
        },
        {
            id: '388',
            label: 'Balaghat',
            value: 'balaghat',
        },
        {
            id: '395',
            label: 'Ashok Nagar',
            value: 'ashok nagar',
        },
        {
            id: '404',
            label: 'Tikamgarh',
            value: 'tikamgarh',
        },
        {
            id: '407',
            label: 'Shahdol',
            value: 'shahdol',
        },
        {
            id: '459',
            label: 'Pithampur',
            value: 'pithampur',
        },
        {
            id: '486',
            label: 'Alirajpur',
            value: 'alirajpur',
        },
        {
            id: '517',
            label: 'Mandla',
            value: 'mandla',
        },
        {
            id: '532',
            label: 'Sheopur',
            value: 'sheopur',
        },
        {
            id: '537',
            label: 'Shajapur',
            value: 'shajapur',
        },
        {
            id: '594',
            label: 'Panna',
            value: 'panna',
        },
        {
            id: '631',
            label: 'Raghogarh-Vijaypur',
            value: 'raghogarh-vijaypur',
        },
        {
            id: '634',
            label: 'Sendhwa',
            value: 'sendhwa',
        },
        {
            id: '667',
            label: 'Sidhi',
            value: 'sidhi',
        },
        {
            id: '680',
            label: 'Pipariya',
            value: 'pipariya',
        },
        {
            id: '704',
            label: 'Shujalpur',
            value: 'shujalpur',
        },
        {
            id: '707',
            label: 'Sironj',
            value: 'sironj',
        },
        {
            id: '724',
            label: 'Pandhurna',
            value: 'pandhurna',
        },
        {
            id: '729',
            label: 'Nowgong',
            value: 'nowgong',
        },
        {
            id: '735',
            label: 'Mandideep',
            value: 'mandideep',
        },
        {
            id: '758',
            label: 'Sihora',
            value: 'sihora',
        },
        {
            id: '794',
            label: 'Raisen',
            value: 'raisen',
        },
        {
            id: '795',
            label: 'Lahar',
            value: 'lahar',
        },
        {
            id: '815',
            label: 'Maihar',
            value: 'maihar',
        },
        {
            id: '820',
            label: 'Sanawad',
            value: 'sanawad',
        },
        {
            id: '823',
            label: 'Sabalgarh',
            value: 'sabalgarh',
        },
        {
            id: '845',
            label: 'Umaria',
            value: 'umaria',
        },
        {
            id: '846',
            label: 'Porsa',
            value: 'porsa',
        },
        {
            id: '866',
            label: 'Narsinghgarh',
            value: 'narsinghgarh',
        },
        {
            id: '868',
            label: 'Malaj Khand',
            value: 'malaj khand',
        },
        {
            id: '869',
            label: 'Sarangpur',
            value: 'sarangpur',
        },
        {
            id: '909',
            label: 'Mundi',
            value: 'mundi',
        },
        {
            id: '913',
            label: 'Nepanagar',
            value: 'nepanagar',
        },
        {
            id: '919',
            label: 'Pasan',
            value: 'pasan',
        },
        {
            id: '923',
            label: 'Mahidpur',
            value: 'mahidpur',
        },
        {
            id: '997',
            label: 'Seoni-Malwa',
            value: 'seoni-malwa',
        },
        {
            id: '1006',
            label: 'Rehli',
            value: 'rehli',
        },
        {
            id: '1017',
            label: 'Manawar',
            value: 'manawar',
        },
        {
            id: '1021',
            label: 'Rahatgarh',
            value: 'rahatgarh',
        },
        {
            id: '1022',
            label: 'Panagar',
            value: 'panagar',
        },
        {
            id: '1027',
            label: 'Wara Seoni',
            value: 'wara seoni',
        },
        {
            id: '1031',
            label: 'Tarana',
            value: 'tarana',
        },
        {
            id: '1046',
            label: 'Sausar',
            value: 'sausar',
        },
        {
            id: '1053',
            label: 'Rajgarh',
            value: 'rajgarh',
        },
        {
            id: '1060',
            label: 'Niwari',
            value: 'niwari',
        },
        {
            id: '1084',
            label: 'Mauganj',
            value: 'mauganj',
        },
        {
            id: '1100',
            label: 'Manasa',
            value: 'manasa',
        },
        {
            id: '1101',
            label: 'Nainpur',
            value: 'nainpur',
        },
        {
            id: '1104',
            label: 'Prithvipur',
            value: 'prithvipur',
        },
        {
            id: '1109',
            label: 'Sohagpur',
            value: 'sohagpur',
        },
        {
            id: '1130',
            label: 'Nowrozabad (Khodargama)',
            value: 'nowrozabad (khodargama)',
        },
        {
            id: '1141',
            label: 'Shamgarh',
            value: 'shamgarh',
        },
        {
            id: '1143',
            label: 'Maharajpur',
            value: 'maharajpur',
        },
        {
            id: '1144',
            label: 'Multai',
            value: 'multai',
        },
        {
            id: '1160',
            label: 'Pali',
            value: 'pali',
        },
        {
            id: '1161',
            label: 'Pachore',
            value: 'pachore',
        },
        {
            id: '1166',
            label: 'Rau',
            value: 'rau',
        },
        {
            id: '1175',
            label: 'Mhowgaon',
            value: 'mhowgaon',
        },
        {
            id: '1197',
            label: 'Vijaypur',
            value: 'vijaypur',
        },
        {
            id: '1212',
            label: 'Narsinghgarh',
            value: 'narsinghgarh',
        },
    ],
    maharashtra: [
        {
            id: '1',
            label: 'Mumbai',
            value: 'mumbai',
        },
        {
            id: '8',
            label: 'Pune',
            value: 'pune',
        },
        {
            id: '13',
            label: 'Nagpur',
            value: 'nagpur',
        },
        {
            id: '16',
            label: 'Thane',
            value: 'thane',
        },
        {
            id: '25',
            label: 'Nashik',
            value: 'nashik',
        },
        {
            id: '29',
            label: 'Kalyan-Dombivali',
            value: 'kalyan-dombivali',
        },
        {
            id: '30',
            label: 'Vasai-Virar',
            value: 'vasai-virar',
        },
        {
            id: '50',
            label: 'Solapur',
            value: 'solapur',
        },
        {
            id: '57',
            label: 'Mira-Bhayandar',
            value: 'mira-bhayandar',
        },
        {
            id: '59',
            label: 'Bhiwandi',
            value: 'bhiwandi',
        },
        {
            id: '62',
            label: 'Amravati',
            value: 'amravati',
        },
        {
            id: '73',
            label: 'Nanded-Waghala',
            value: 'nanded-waghala',
        },
        {
            id: '77',
            label: 'Sangli',
            value: 'sangli',
        },
        {
            id: '87',
            label: 'Malegaon',
            value: 'malegaon',
        },
        {
            id: '92',
            label: 'Akola',
            value: 'akola',
        },
        {
            id: '99',
            label: 'Latur',
            value: 'latur',
        },
        {
            id: '100',
            label: 'Dhule',
            value: 'dhule',
        },
        {
            id: '106',
            label: 'Ahmednagar',
            value: 'ahmednagar',
        },
        {
            id: '123',
            label: 'Ichalkaranji',
            value: 'ichalkaranji',
        },
        {
            id: '139',
            label: 'Parbhani',
            value: 'parbhani',
        },
        {
            id: '165',
            label: 'Panvel',
            value: 'panvel',
        },
        {
            id: '279',
            label: 'Yavatmal',
            value: 'yavatmal',
        },
        {
            id: '293',
            label: 'Achalpur',
            value: 'achalpur',
        },
        {
            id: '294',
            label: 'Osmanabad',
            value: 'osmanabad',
        },
        {
            id: '296',
            label: 'Nandurbar',
            value: 'nandurbar',
        },
        {
            id: '307',
            label: 'Satara',
            value: 'satara',
        },
        {
            id: '311',
            label: 'Wardha',
            value: 'wardha',
        },
        {
            id: '317',
            label: 'Udgir',
            value: 'udgir',
        },
        {
            id: '321',
            label: 'Aurangabad',
            value: 'aurangabad',
        },
        {
            id: '345',
            label: 'Amalner',
            value: 'amalner',
        },
        {
            id: '355',
            label: 'Akot',
            value: 'akot',
        },
        {
            id: '360',
            label: 'Pandharpur',
            value: 'pandharpur',
        },
        {
            id: '366',
            label: 'Shrirampur',
            value: 'shrirampur',
        },
        {
            id: '368',
            label: 'Parli',
            value: 'parli',
        },
        {
            id: '410',
            label: 'Washim',
            value: 'washim',
        },
        {
            id: '424',
            label: 'Ambejogai',
            value: 'ambejogai',
        },
        {
            id: '436',
            label: 'Manmad',
            value: 'manmad',
        },
        {
            id: '451',
            label: 'Ratnagiri',
            value: 'ratnagiri',
        },
        {
            id: '463',
            label: 'Uran Islampur',
            value: 'uran islampur',
        },
        {
            id: '467',
            label: 'Pusad',
            value: 'pusad',
        },
        {
            id: '503',
            label: 'Sangamner',
            value: 'sangamner',
        },
        {
            id: '509',
            label: 'Shirpur-Warwade',
            value: 'shirpur-warwade',
        },
        {
            id: '513',
            label: 'Malkapur',
            value: 'malkapur',
        },
        {
            id: '525',
            label: 'Wani',
            value: 'wani',
        },
        {
            id: '539',
            label: 'Lonavla',
            value: 'lonavla',
        },
        {
            id: '552',
            label: 'Talegaon Dabhade',
            value: 'talegaon dabhade',
        },
        {
            id: '553',
            label: 'Anjangaon',
            value: 'anjangaon',
        },
        {
            id: '573',
            label: 'Umred',
            value: 'umred',
        },
        {
            id: '590',
            label: 'Palghar',
            value: 'palghar',
        },
        {
            id: '591',
            label: 'Shegaon',
            value: 'shegaon',
        },
        {
            id: '604',
            label: 'Ozar',
            value: 'ozar',
        },
        {
            id: '608',
            label: 'Phaltan',
            value: 'phaltan',
        },
        {
            id: '622',
            label: 'Yevla',
            value: 'yevla',
        },
        {
            id: '626',
            label: 'Shahade',
            value: 'shahade',
        },
        {
            id: '641',
            label: 'Vita',
            value: 'vita',
        },
        {
            id: '650',
            label: 'Umarkhed',
            value: 'umarkhed',
        },
        {
            id: '658',
            label: 'Warora',
            value: 'warora',
        },
        {
            id: '671',
            label: 'Pachora',
            value: 'pachora',
        },
        {
            id: '674',
            label: 'Tumsar',
            value: 'tumsar',
        },
        {
            id: '688',
            label: 'Manjlegaon',
            value: 'manjlegaon',
        },
        {
            id: '690',
            label: 'Sillod',
            value: 'sillod',
        },
        {
            id: '698',
            label: 'Arvi',
            value: 'arvi',
        },
        {
            id: '708',
            label: 'Nandura',
            value: 'nandura',
        },
        {
            id: '720',
            label: 'Vaijapur',
            value: 'vaijapur',
        },
        {
            id: '725',
            label: 'Wadgaon Road',
            value: 'wadgaon road',
        },
        {
            id: '736',
            label: 'Sailu',
            value: 'sailu',
        },
        {
            id: '748',
            label: 'Murtijapur',
            value: 'murtijapur',
        },
        {
            id: '756',
            label: 'Tasgaon',
            value: 'tasgaon',
        },
        {
            id: '761',
            label: 'Mehkar',
            value: 'mehkar',
        },
        {
            id: '780',
            label: 'Yawal',
            value: 'yawal',
        },
        {
            id: '783',
            label: 'Pulgaon',
            value: 'pulgaon',
        },
        {
            id: '788',
            label: 'Nilanga',
            value: 'nilanga',
        },
        {
            id: '791',
            label: 'Wai',
            value: 'wai',
        },
        {
            id: '800',
            label: 'Umarga',
            value: 'umarga',
        },
        {
            id: '810',
            label: 'Paithan',
            value: 'paithan',
        },
        {
            id: '811',
            label: 'Rahuri',
            value: 'rahuri',
        },
        {
            id: '817',
            label: 'Nawapur',
            value: 'nawapur',
        },
        {
            id: '824',
            label: 'Tuljapur',
            value: 'tuljapur',
        },
        {
            id: '836',
            label: 'Morshi',
            value: 'morshi',
        },
        {
            id: '842',
            label: 'Purna',
            value: 'purna',
        },
        {
            id: '856',
            label: 'Satana',
            value: 'satana',
        },
        {
            id: '878',
            label: 'Pathri',
            value: 'pathri',
        },
        {
            id: '881',
            label: 'Sinnar',
            value: 'sinnar',
        },
        {
            id: '891',
            label: 'Uchgaon',
            value: 'uchgaon',
        },
        {
            id: '901',
            label: 'Uran',
            value: 'uran',
        },
        {
            id: '904',
            label: 'Pen',
            value: 'pen',
        },
        {
            id: '914',
            label: 'Karjat',
            value: 'karjat',
        },
        {
            id: '928',
            label: 'Manwath',
            value: 'manwath',
        },
        {
            id: '931',
            label: 'Partur',
            value: 'partur',
        },
        {
            id: '948',
            label: 'Sangole',
            value: 'sangole',
        },
        {
            id: '957',
            label: 'Mangrulpir',
            value: 'mangrulpir',
        },
        {
            id: '968',
            label: 'Risod',
            value: 'risod',
        },
        {
            id: '978',
            label: 'Shirur',
            value: 'shirur',
        },
        {
            id: '984',
            label: 'Savner',
            value: 'savner',
        },
        {
            id: '985',
            label: 'Sasvad',
            value: 'sasvad',
        },
        {
            id: '989',
            label: 'Pandharkaoda',
            value: 'pandharkaoda',
        },
        {
            id: '993',
            label: 'Talode',
            value: 'talode',
        },
        {
            id: '994',
            label: 'Shrigonda',
            value: 'shrigonda',
        },
        {
            id: '998',
            label: 'Shirdi',
            value: 'shirdi',
        },
        {
            id: '1001',
            label: 'Raver',
            value: 'raver',
        },
        {
            id: '1004',
            label: 'Mukhed',
            value: 'mukhed',
        },
        {
            id: '1008',
            label: 'Rajura',
            value: 'rajura',
        },
        {
            id: '1011',
            label: 'Vadgaon Kasba',
            value: 'vadgaon kasba',
        },
        {
            id: '1024',
            label: 'Tirora',
            value: 'tirora',
        },
        {
            id: '1048',
            label: 'Mahad',
            value: 'mahad',
        },
        {
            id: '1070',
            label: 'Lonar',
            value: 'lonar',
        },
        {
            id: '1089',
            label: 'Sawantwadi',
            value: 'sawantwadi',
        },
        {
            id: '1093',
            label: 'Pathardi',
            value: 'pathardi',
        },
        {
            id: '1103',
            label: 'Pauni',
            value: 'pauni',
        },
        {
            id: '1105',
            label: 'Ramtek',
            value: 'ramtek',
        },
        {
            id: '1110',
            label: 'Mul',
            value: 'mul',
        },
        {
            id: '1132',
            label: 'Soyagaon',
            value: 'soyagaon',
        },
        {
            id: '1136',
            label: 'Mangalvedhe',
            value: 'mangalvedhe',
        },
        {
            id: '1153',
            label: 'Narkhed',
            value: 'narkhed',
        },
        {
            id: '1155',
            label: 'Shendurjana',
            value: 'shendurjana',
        },
        {
            id: '1173',
            label: 'Patur',
            value: 'patur',
        },
        {
            id: '1177',
            label: 'Mhaswad',
            value: 'mhaswad',
        },
        {
            id: '1188',
            label: 'Loha',
            value: 'loha',
        },
        {
            id: '1204',
            label: 'Nandgaon',
            value: 'nandgaon',
        },
        {
            id: '1213',
            label: 'Warud',
            value: 'warud',
        },
    ],
    manipur: [
        {
            id: '133',
            label: 'Imphal',
            value: 'imphal',
        },
        {
            id: '664',
            label: 'Thoubal',
            value: 'thoubal',
        },
        {
            id: '1091',
            label: 'Lilong',
            value: 'lilong',
        },
        {
            id: '1174',
            label: 'Mayang Imphal',
            value: 'mayang imphal',
        },
    ],
    meghalaya: [
        {
            id: '132',
            label: 'Shillong',
            value: 'shillong',
        },
        {
            id: '420',
            label: 'Tura',
            value: 'tura',
        },
        {
            id: '935',
            label: 'Nongstoin',
            value: 'nongstoin',
        },
    ],
    mizoram: [
        {
            id: '122',
            label: 'Aizawl',
            value: 'aizawl',
        },
        {
            id: '547',
            label: 'Lunglei',
            value: 'lunglei',
        },
        {
            id: '1192',
            label: 'Saiha',
            value: 'saiha',
        },
    ],
    nagaland: [
        {
            id: '265',
            label: 'Dimapur',
            value: 'dimapur',
        },
        {
            id: '339',
            label: 'Kohima',
            value: 'kohima',
        },
        {
            id: '765',
            label: 'Zunheboto',
            value: 'zunheboto',
        },
        {
            id: '777',
            label: 'Tuensang',
            value: 'tuensang',
        },
        {
            id: '805',
            label: 'Wokha',
            value: 'wokha',
        },
        {
            id: '892',
            label: 'Mokokchung',
            value: 'mokokchung',
        },
    ],
    odisha: [
        {
            id: '54',
            label: 'Bhubaneswar',
            value: 'bhubaneswar',
        },
        {
            id: '67',
            label: 'Cuttack',
            value: 'cuttack',
        },
        {
            id: '84',
            label: 'Raurkela',
            value: 'raurkela',
        },
        {
            id: '103',
            label: 'Brahmapur',
            value: 'brahmapur',
        },
        {
            id: '186',
            label: 'Sambalpur',
            value: 'sambalpur',
        },
        {
            id: '211',
            label: 'Puri',
            value: 'puri',
        },
        {
            id: '275',
            label: 'Baleshwar Town',
            value: 'baleshwar town',
        },
        {
            id: '300',
            label: 'Baripada Town',
            value: 'baripada town',
        },
        {
            id: '308',
            label: 'Bhadrak',
            value: 'bhadrak',
        },
        {
            id: '340',
            label: 'Balangir',
            value: 'balangir',
        },
        {
            id: '342',
            label: 'Jharsuguda',
            value: 'jharsuguda',
        },
        {
            id: '398',
            label: 'Bargarh',
            value: 'bargarh',
        },
        {
            id: '427',
            label: 'Paradip',
            value: 'paradip',
        },
        {
            id: '457',
            label: 'Bhawanipatna',
            value: 'bhawanipatna',
        },
        {
            id: '462',
            label: 'Dhenkanal',
            value: 'dhenkanal',
        },
        {
            id: '474',
            label: 'Barbil',
            value: 'barbil',
        },
        {
            id: '516',
            label: 'Kendujhar',
            value: 'kendujhar',
        },
        {
            id: '524',
            label: 'Sunabeda',
            value: 'sunabeda',
        },
        {
            id: '538',
            label: 'Rayagada',
            value: 'rayagada',
        },
        {
            id: '560',
            label: 'Jatani',
            value: 'jatani',
        },
        {
            id: '635',
            label: 'Byasanagar',
            value: 'byasanagar',
        },
        {
            id: '654',
            label: 'Kendrapara',
            value: 'kendrapara',
        },
        {
            id: '693',
            label: 'Rajagangapur',
            value: 'rajagangapur',
        },
        {
            id: '695',
            label: 'Parlakhemundi',
            value: 'parlakhemundi',
        },
        {
            id: '726',
            label: 'Talcher',
            value: 'talcher',
        },
        {
            id: '750',
            label: 'Sundargarh',
            value: 'sundargarh',
        },
        {
            id: '828',
            label: 'Phulabani',
            value: 'phulabani',
        },
        {
            id: '852',
            label: 'Pattamundai',
            value: 'pattamundai',
        },
        {
            id: '890',
            label: 'Titlagarh',
            value: 'titlagarh',
        },
        {
            id: '910',
            label: 'Nabarangapur',
            value: 'nabarangapur',
        },
        {
            id: '958',
            label: 'Soro',
            value: 'soro',
        },
        {
            id: '1082',
            label: 'Malkangiri',
            value: 'malkangiri',
        },
        {
            id: '1128',
            label: 'Rairangpur',
            value: 'rairangpur',
        },
        {
            id: '1210',
            label: 'Tarbha',
            value: 'tarbha',
        },
    ],
    puducherry: [
        {
            id: '80',
            label: 'Pondicherry',
            value: 'pondicherry',
        },
        {
            id: '380',
            label: 'Karaikal',
            value: 'karaikal',
        },
        {
            id: '563',
            label: 'Yanam',
            value: 'yanam',
        },
        {
            id: '774',
            label: 'Mahe',
            value: 'mahe',
        },
    ],
    punjab: [
        {
            id: '21',
            label: 'Ludhiana',
            value: 'ludhiana',
        },
        {
            id: '27',
            label: 'Patiala',
            value: 'patiala',
        },
        {
            id: '35',
            label: 'Amritsar',
            value: 'amritsar',
        },
        {
            id: '52',
            label: 'Jalandhar',
            value: 'jalandhar',
        },
        {
            id: '126',
            label: 'Bathinda',
            value: 'bathinda',
        },
        {
            id: '199',
            label: 'Pathankot',
            value: 'pathankot',
        },
        {
            id: '200',
            label: 'Hoshiarpur',
            value: 'hoshiarpur',
        },
        {
            id: '214',
            label: 'Batala',
            value: 'batala',
        },
        {
            id: '227',
            label: 'Moga',
            value: 'moga',
        },
        {
            id: '251',
            label: 'Malerkotla',
            value: 'malerkotla',
        },
        {
            id: '255',
            label: 'Khanna',
            value: 'khanna',
        },
        {
            id: '266',
            label: 'Mohali',
            value: 'mohali',
        },
        {
            id: '280',
            label: 'Barnala',
            value: 'barnala',
        },
        {
            id: '299',
            label: 'Firozpur',
            value: 'firozpur',
        },
        {
            id: '323',
            label: 'Phagwara',
            value: 'phagwara',
        },
        {
            id: '326',
            label: 'Kapurthala',
            value: 'kapurthala',
        },
        {
            id: '346',
            label: 'Zirakpur',
            value: 'zirakpur',
        },
        {
            id: '358',
            label: 'Kot Kapura',
            value: 'kot kapura',
        },
        {
            id: '384',
            label: 'Faridkot',
            value: 'faridkot',
        },
        {
            id: '391',
            label: 'Muktsar',
            value: 'muktsar',
        },
        {
            id: '392',
            label: 'Rajpura',
            value: 'rajpura',
        },
        {
            id: '411',
            label: 'Sangrur',
            value: 'sangrur',
        },
        {
            id: '413',
            label: 'Fazilka',
            value: 'fazilka',
        },
        {
            id: '418',
            label: 'Gurdaspur',
            value: 'gurdaspur',
        },
        {
            id: '422',
            label: 'Kharar',
            value: 'kharar',
        },
        {
            id: '432',
            label: 'Gobindgarh',
            value: 'gobindgarh',
        },
        {
            id: '434',
            label: 'Mansa',
            value: 'mansa',
        },
        {
            id: '448',
            label: 'Malout',
            value: 'malout',
        },
        {
            id: '460',
            label: 'Nabha',
            value: 'nabha',
        },
        {
            id: '470',
            label: 'Tarn Taran',
            value: 'tarn taran',
        },
        {
            id: '484',
            label: 'Jagraon',
            value: 'jagraon',
        },
        {
            id: '555',
            label: 'Sunam',
            value: 'sunam',
        },
        {
            id: '566',
            label: 'Dhuri',
            value: 'dhuri',
        },
        {
            id: '586',
            label: 'Firozpur Cantt.',
            value: 'firozpur cantt.',
        },
        {
            id: '623',
            label: 'Sirhind Fatehgarh Sahib',
            value: 'sirhind fatehgarh sahib',
        },
        {
            id: '632',
            label: 'Rupnagar',
            value: 'rupnagar',
        },
        {
            id: '644',
            label: 'Jalandhar Cantt.',
            value: 'jalandhar cantt.',
        },
        {
            id: '657',
            label: 'Samana',
            value: 'samana',
        },
        {
            id: '663',
            label: 'Nawanshahr',
            value: 'nawanshahr',
        },
        {
            id: '677',
            label: 'Rampura Phul',
            value: 'rampura phul',
        },
        {
            id: '721',
            label: 'Nangal',
            value: 'nangal',
        },
        {
            id: '771',
            label: 'Nakodar',
            value: 'nakodar',
        },
        {
            id: '779',
            label: 'Zira',
            value: 'zira',
        },
        {
            id: '812',
            label: 'Patti',
            value: 'patti',
        },
        {
            id: '1034',
            label: 'Raikot',
            value: 'raikot',
        },
        {
            id: '1056',
            label: 'Longowal',
            value: 'longowal',
        },
        {
            id: '1069',
            label: 'Urmar Tanda',
            value: 'urmar tanda',
        },
        {
            id: '1099',
            label: 'Morinda, India',
            value: 'morinda, india',
        },
        {
            id: '1112',
            label: 'Phillaur',
            value: 'phillaur',
        },
        {
            id: '1116',
            label: 'Pattran',
            value: 'pattran',
        },
        {
            id: '1127',
            label: 'Qadian',
            value: 'qadian',
        },
        {
            id: '1133',
            label: 'Sujanpur',
            value: 'sujanpur',
        },
        {
            id: '1145',
            label: 'Mukerian',
            value: 'mukerian',
        },
        {
            id: '1194',
            label: 'Talwara',
            value: 'talwara',
        },
    ],
    rajasthan: [
        {
            id: '9',
            label: 'Jaipur',
            value: 'jaipur',
        },
        {
            id: '34',
            label: 'Jodhpur',
            value: 'jodhpur',
        },
        {
            id: '63',
            label: 'Bikaner',
            value: 'bikaner',
        },
        {
            id: '69',
            label: 'Udaipur',
            value: 'udaipur',
        },
        {
            id: '74',
            label: 'Ajmer',
            value: 'ajmer',
        },
        {
            id: '102',
            label: 'Bhilwara',
            value: 'bhilwara',
        },
        {
            id: '112',
            label: 'Alwar',
            value: 'alwar',
        },
        {
            id: '141',
            label: 'Bharatpur',
            value: 'bharatpur',
        },
        {
            id: '147',
            label: 'Pali',
            value: 'pali',
        },
        {
            id: '176',
            label: 'Barmer',
            value: 'barmer',
        },
        {
            id: '180',
            label: 'Sikar',
            value: 'sikar',
        },
        {
            id: '204',
            label: 'Tonk',
            value: 'tonk',
        },
        {
            id: '267',
            label: 'Sadulpur',
            value: 'sadulpur',
        },
        {
            id: '325',
            label: 'Sawai Madhopur',
            value: 'sawai madhopur',
        },
        {
            id: '331',
            label: 'Nagaur',
            value: 'nagaur',
        },
        {
            id: '359',
            label: 'Makrana',
            value: 'makrana',
        },
        {
            id: '389',
            label: 'Sujangarh',
            value: 'sujangarh',
        },
        {
            id: '396',
            label: 'Sardarshahar',
            value: 'sardarshahar',
        },
        {
            id: '479',
            label: 'Ladnu',
            value: 'ladnu',
        },
        {
            id: '491',
            label: 'Ratangarh',
            value: 'ratangarh',
        },
        {
            id: '496',
            label: 'Nokha',
            value: 'nokha',
        },
        {
            id: '504',
            label: 'Nimbahera',
            value: 'nimbahera',
        },
        {
            id: '536',
            label: 'Suratgarh',
            value: 'suratgarh',
        },
        {
            id: '562',
            label: 'Rajsamand',
            value: 'rajsamand',
        },
        {
            id: '583',
            label: 'Lachhmangarh',
            value: 'lachhmangarh',
        },
        {
            id: '601',
            label: 'Rajgarh (Churu)',
            value: 'rajgarh (churu)',
        },
        {
            id: '607',
            label: 'Nasirabad',
            value: 'nasirabad',
        },
        {
            id: '621',
            label: 'Nohar',
            value: 'nohar',
        },
        {
            id: '675',
            label: 'Phalodi',
            value: 'phalodi',
        },
        {
            id: '710',
            label: 'Nathdwara',
            value: 'nathdwara',
        },
        {
            id: '728',
            label: 'Pilani',
            value: 'pilani',
        },
        {
            id: '733',
            label: 'Merta City',
            value: 'merta city',
        },
        {
            id: '745',
            label: 'Sojat',
            value: 'sojat',
        },
        {
            id: '786',
            label: 'Neem-Ka-Thana',
            value: 'neem-ka-thana',
        },
        {
            id: '798',
            label: 'Sirohi',
            value: 'sirohi',
        },
        {
            id: '801',
            label: 'Pratapgarh',
            value: 'pratapgarh',
        },
        {
            id: '808',
            label: 'Rawatbhata',
            value: 'rawatbhata',
        },
        {
            id: '809',
            label: 'Sangaria',
            value: 'sangaria',
        },
        {
            id: '814',
            label: 'Lalsot',
            value: 'lalsot',
        },
        {
            id: '835',
            label: 'Pilibanga',
            value: 'pilibanga',
        },
        {
            id: '851',
            label: 'Pipar City',
            value: 'pipar city',
        },
        {
            id: '854',
            label: 'Taranagar',
            value: 'taranagar',
        },
        {
            id: '876',
            label: 'Vijainagar, Ajmer',
            value: 'vijainagar, ajmer',
        },
        {
            id: '885',
            label: 'Sumerpur',
            value: 'sumerpur',
        },
        {
            id: '894',
            label: 'Sagwara',
            value: 'sagwara',
        },
        {
            id: '895',
            label: 'Ramganj Mandi',
            value: 'ramganj mandi',
        },
        {
            id: '918',
            label: 'Lakheri',
            value: 'lakheri',
        },
        {
            id: '927',
            label: 'Udaipurwati',
            value: 'udaipurwati',
        },
        {
            id: '936',
            label: 'Losal',
            value: 'losal',
        },
        {
            id: '937',
            label: 'Sri Madhopur',
            value: 'sri madhopur',
        },
        {
            id: '938',
            label: 'Ramngarh',
            value: 'ramngarh',
        },
        {
            id: '940',
            label: 'Rawatsar',
            value: 'rawatsar',
        },
        {
            id: '941',
            label: 'Rajakhera',
            value: 'rajakhera',
        },
        {
            id: '946',
            label: 'Shahpura',
            value: 'shahpura',
        },
        {
            id: '959',
            label: 'Shahpura',
            value: 'shahpura',
        },
        {
            id: '961',
            label: 'Raisinghnagar',
            value: 'raisinghnagar',
        },
        {
            id: '971',
            label: 'Malpura',
            value: 'malpura',
        },
        {
            id: '992',
            label: 'Nadbai',
            value: 'nadbai',
        },
        {
            id: '1007',
            label: 'Sanchore',
            value: 'sanchore',
        },
        {
            id: '1012',
            label: 'Nagar',
            value: 'nagar',
        },
        {
            id: '1029',
            label: 'Rajgarh (Alwar)',
            value: 'rajgarh (alwar)',
        },
        {
            id: '1033',
            label: 'Sheoganj',
            value: 'sheoganj',
        },
        {
            id: '1041',
            label: 'Sadri',
            value: 'sadri',
        },
        {
            id: '1066',
            label: 'Todaraisingh',
            value: 'todaraisingh',
        },
        {
            id: '1085',
            label: 'Todabhim',
            value: 'todabhim',
        },
        {
            id: '1088',
            label: 'Reengus',
            value: 'reengus',
        },
        {
            id: '1092',
            label: 'Rajaldesar',
            value: 'rajaldesar',
        },
        {
            id: '1111',
            label: 'Sadulshahar',
            value: 'sadulshahar',
        },
        {
            id: '1113',
            label: 'Sambhar',
            value: 'sambhar',
        },
        {
            id: '1114',
            label: 'Prantij',
            value: 'prantij',
        },
        {
            id: '1117',
            label: 'Mount Abu',
            value: 'mount abu',
        },
        {
            id: '1131',
            label: 'Mangrol',
            value: 'mangrol',
        },
        {
            id: '1137',
            label: 'Phulera',
            value: 'phulera',
        },
        {
            id: '1168',
            label: 'Mandawa',
            value: 'mandawa',
        },
        {
            id: '1171',
            label: 'Pindwara',
            value: 'pindwara',
        },
        {
            id: '1187',
            label: 'Mandalgarh',
            value: 'mandalgarh',
        },
        {
            id: '1198',
            label: 'Takhatgarh',
            value: 'takhatgarh',
        },
        {
            id: '1220',
            label: 'Kota',
            value: 'kota',
        },
    ],
    sikkim: [
        {
            id: 'Sikkim',
            label: 'Sikkim',
            value: 'sikkim',
        },
    ],
    'tamil nadu': [
        {
            id: '6',
            label: 'Chennai',
            value: 'chennai',
        },
        {
            id: '38',
            label: 'Coimbatore',
            value: 'coimbatore',
        },
        {
            id: '42',
            label: 'Madurai',
            value: 'madurai',
        },
        {
            id: '53',
            label: 'Tiruchirappalli',
            value: 'tiruchirappalli',
        },
        {
            id: '55',
            label: 'Salem',
            value: 'salem',
        },
        {
            id: '86',
            label: 'Tirunelveli',
            value: 'tirunelveli',
        },
        {
            id: '89',
            label: 'Tiruppur',
            value: 'tiruppur',
        },
        {
            id: '135',
            label: 'Ranipet',
            value: 'ranipet',
        },
        {
            id: '153',
            label: 'Nagercoil',
            value: 'nagercoil',
        },
        {
            id: '154',
            label: 'Thanjavur',
            value: 'thanjavur',
        },
        {
            id: '181',
            label: 'Vellore',
            value: 'vellore',
        },
        {
            id: '206',
            label: 'Kancheepuram',
            value: 'kancheepuram',
        },
        {
            id: '213',
            label: 'Erode',
            value: 'erode',
        },
        {
            id: '238',
            label: 'Tiruvannamalai',
            value: 'tiruvannamalai',
        },
        {
            id: '254',
            label: 'Pollachi',
            value: 'pollachi',
        },
        {
            id: '268',
            label: 'Rajapalayam',
            value: 'rajapalayam',
        },
        {
            id: '271',
            label: 'Sivakasi',
            value: 'sivakasi',
        },
        {
            id: '304',
            label: 'Pudukkottai',
            value: 'pudukkottai',
        },
        {
            id: '314',
            label: 'Neyveli (TS)',
            value: 'neyveli (ts)',
        },
        {
            id: '319',
            label: 'Nagapattinam',
            value: 'nagapattinam',
        },
        {
            id: '344',
            label: 'Viluppuram',
            value: 'viluppuram',
        },
        {
            id: '348',
            label: 'Tiruchengode',
            value: 'tiruchengode',
        },
        {
            id: '351',
            label: 'Vaniyambadi',
            value: 'vaniyambadi',
        },
        {
            id: '353',
            label: 'Theni Allinagaram',
            value: 'theni allinagaram',
        },
        {
            id: '371',
            label: 'Udhagamandalam',
            value: 'udhagamandalam',
        },
        {
            id: '374',
            label: 'Aruppukkottai',
            value: 'aruppukkottai',
        },
        {
            id: '387',
            label: 'Paramakudi',
            value: 'paramakudi',
        },
        {
            id: '409',
            label: 'Arakkonam',
            value: 'arakkonam',
        },
        {
            id: '428',
            label: 'Virudhachalam',
            value: 'virudhachalam',
        },
        {
            id: '431',
            label: 'Srivilliputhur',
            value: 'srivilliputhur',
        },
        {
            id: '433',
            label: 'Tindivanam',
            value: 'tindivanam',
        },
        {
            id: '439',
            label: 'Virudhunagar',
            value: 'virudhunagar',
        },
        {
            id: '442',
            label: 'Karur',
            value: 'karur',
        },
        {
            id: '443',
            label: 'Valparai',
            value: 'valparai',
        },
        {
            id: '449',
            label: 'Sankarankovil',
            value: 'sankarankovil',
        },
        {
            id: '450',
            label: 'Tenkasi',
            value: 'tenkasi',
        },
        {
            id: '466',
            label: 'Palani',
            value: 'palani',
        },
        {
            id: '480',
            label: 'Pattukkottai',
            value: 'pattukkottai',
        },
        {
            id: '489',
            label: 'Tirupathur',
            value: 'tirupathur',
        },
        {
            id: '499',
            label: 'Ramanathapuram',
            value: 'ramanathapuram',
        },
        {
            id: '512',
            label: 'Udumalaipettai',
            value: 'udumalaipettai',
        },
        {
            id: '523',
            label: 'Gobichettipalayam',
            value: 'gobichettipalayam',
        },
        {
            id: '533',
            label: 'Thiruvarur',
            value: 'thiruvarur',
        },
        {
            id: '557',
            label: 'Thiruvallur',
            value: 'thiruvallur',
        },
        {
            id: '565',
            label: 'Panruti',
            value: 'panruti',
        },
        {
            id: '567',
            label: 'Namakkal',
            value: 'namakkal',
        },
        {
            id: '605',
            label: 'Thirumangalam',
            value: 'thirumangalam',
        },
        {
            id: '652',
            label: 'Vikramasingapuram',
            value: 'vikramasingapuram',
        },
        {
            id: '656',
            label: 'Nellikuppam',
            value: 'nellikuppam',
        },
        {
            id: '660',
            label: 'Rasipuram',
            value: 'rasipuram',
        },
        {
            id: '676',
            label: 'Tiruttani',
            value: 'tiruttani',
        },
        {
            id: '686',
            label: 'Nandivaram-Guduvancheri',
            value: 'nandivaram-guduvancheri',
        },
        {
            id: '711',
            label: 'Periyakulam',
            value: 'periyakulam',
        },
        {
            id: '717',
            label: 'Pernampattu',
            value: 'pernampattu',
        },
        {
            id: '732',
            label: 'Vellakoil',
            value: 'vellakoil',
        },
        {
            id: '734',
            label: 'Sivaganga',
            value: 'sivaganga',
        },
        {
            id: '739',
            label: 'Vadalur',
            value: 'vadalur',
        },
        {
            id: '755',
            label: 'Rameshwaram',
            value: 'rameshwaram',
        },
        {
            id: '759',
            label: 'Tiruvethipuram',
            value: 'tiruvethipuram',
        },
        {
            id: '763',
            label: 'Perambalur',
            value: 'perambalur',
        },
        {
            id: '803',
            label: 'Usilampatti',
            value: 'usilampatti',
        },
        {
            id: '816',
            label: 'Vedaranyam',
            value: 'vedaranyam',
        },
        {
            id: '834',
            label: 'Sathyamangalam',
            value: 'sathyamangalam',
        },
        {
            id: '843',
            label: 'Puliyankudi',
            value: 'puliyankudi',
        },
        {
            id: '853',
            label: 'Nanjikottai',
            value: 'nanjikottai',
        },
        {
            id: '860',
            label: 'Thuraiyur',
            value: 'thuraiyur',
        },
        {
            id: '871',
            label: 'Sirkali',
            value: 'sirkali',
        },
        {
            id: '873',
            label: 'Tiruchendur',
            value: 'tiruchendur',
        },
        {
            id: '877',
            label: 'Periyasemur',
            value: 'periyasemur',
        },
        {
            id: '886',
            label: 'Sattur',
            value: 'sattur',
        },
        {
            id: '889',
            label: 'Vandavasi',
            value: 'vandavasi',
        },
        {
            id: '902',
            label: 'Tharamangalam',
            value: 'tharamangalam',
        },
        {
            id: '903',
            label: 'Tirukkoyilur',
            value: 'tirukkoyilur',
        },
        {
            id: '907',
            label: 'Oddanchatram',
            value: 'oddanchatram',
        },
        {
            id: '908',
            label: 'Palladam',
            value: 'palladam',
        },
        {
            id: '921',
            label: 'Vadakkuvalliyur',
            value: 'vadakkuvalliyur',
        },
        {
            id: '922',
            label: 'Tirukalukundram',
            value: 'tirukalukundram',
        },
        {
            id: '930',
            label: 'Uthamapalayam',
            value: 'uthamapalayam',
        },
        {
            id: '947',
            label: 'Surandai',
            value: 'surandai',
        },
        {
            id: '970',
            label: 'Sankari',
            value: 'sankari',
        },
        {
            id: '980',
            label: 'Shenkottai',
            value: 'shenkottai',
        },
        {
            id: '982',
            label: 'Vadipatti',
            value: 'vadipatti',
        },
        {
            id: '988',
            label: 'Sholingur',
            value: 'sholingur',
        },
        {
            id: '1002',
            label: 'Tirupathur',
            value: 'tirupathur',
        },
        {
            id: '1005',
            label: 'Manachanallur',
            value: 'manachanallur',
        },
        {
            id: '1014',
            label: 'Viswanatham',
            value: 'viswanatham',
        },
        {
            id: '1015',
            label: 'Polur',
            value: 'polur',
        },
        {
            id: '1016',
            label: 'Panagudi',
            value: 'panagudi',
        },
        {
            id: '1023',
            label: 'Uthiramerur',
            value: 'uthiramerur',
        },
        {
            id: '1042',
            label: 'Thiruthuraipoondi',
            value: 'thiruthuraipoondi',
        },
        {
            id: '1044',
            label: 'Pallapatti',
            value: 'pallapatti',
        },
        {
            id: '1047',
            label: 'Ponneri',
            value: 'ponneri',
        },
        {
            id: '1058',
            label: 'Lalgudi',
            value: 'lalgudi',
        },
        {
            id: '1061',
            label: 'Natham',
            value: 'natham',
        },
        {
            id: '1062',
            label: 'Unnamalaikadai',
            value: 'unnamalaikadai',
        },
        {
            id: '1072',
            label: 'P.N.Patti',
            value: 'p.n.patti',
        },
        {
            id: '1079',
            label: 'Tharangambadi',
            value: 'tharangambadi',
        },
        {
            id: '1090',
            label: 'Tittakudi',
            value: 'tittakudi',
        },
        {
            id: '1095',
            label: 'Pacode',
            value: 'pacode',
        },
        {
            id: '1124',
            label: "O' Valley",
            value: "o' valley",
        },
        {
            id: '1126',
            label: 'Suriyampalayam',
            value: 'suriyampalayam',
        },
        {
            id: '1139',
            label: 'Sholavandan',
            value: 'sholavandan',
        },
        {
            id: '1142',
            label: 'Thammampatti',
            value: 'thammampatti',
        },
        {
            id: '1149',
            label: 'Namagiripettai',
            value: 'namagiripettai',
        },
        {
            id: '1156',
            label: 'Peravurani',
            value: 'peravurani',
        },
        {
            id: '1162',
            label: 'Parangipettai',
            value: 'parangipettai',
        },
        {
            id: '1163',
            label: 'Pudupattinam',
            value: 'pudupattinam',
        },
        {
            id: '1170',
            label: 'Pallikonda',
            value: 'pallikonda',
        },
        {
            id: '1179',
            label: 'Sivagiri',
            value: 'sivagiri',
        },
        {
            id: '1181',
            label: 'Punjaipugalur',
            value: 'punjaipugalur',
        },
        {
            id: '1190',
            label: 'Padmanabhapuram',
            value: 'padmanabhapuram',
        },
        {
            id: '1199',
            label: 'Thirupuvanam',
            value: 'thirupuvanam',
        },
    ],
    telangana: [
        {
            id: '5',
            label: 'Hyderabad',
            value: 'hyderabad',
        },
        {
            id: '56',
            label: 'Warangal',
            value: 'warangal',
        },
        {
            id: '114',
            label: 'Nizamabad',
            value: 'nizamabad',
        },
        {
            id: '138',
            label: 'Karimnagar',
            value: 'karimnagar',
        },
        {
            id: '146',
            label: 'Ramagundam',
            value: 'ramagundam',
        },
        {
            id: '183',
            label: 'Khammam',
            value: 'khammam',
        },
        {
            id: '210',
            label: 'Mahbubnagar',
            value: 'mahbubnagar',
        },
        {
            id: '276',
            label: 'Mancherial',
            value: 'mancherial',
        },
        {
            id: '278',
            label: 'Adilabad',
            value: 'adilabad',
        },
        {
            id: '310',
            label: 'Suryapet',
            value: 'suryapet',
        },
        {
            id: '343',
            label: 'Jagtial',
            value: 'jagtial',
        },
        {
            id: '361',
            label: 'Miryalaguda',
            value: 'miryalaguda',
        },
        {
            id: '370',
            label: 'Nirmal',
            value: 'nirmal',
        },
        {
            id: '399',
            label: 'Kamareddy',
            value: 'kamareddy',
        },
        {
            id: '401',
            label: 'Kothagudem',
            value: 'kothagudem',
        },
        {
            id: '412',
            label: 'Bodhan',
            value: 'bodhan',
        },
        {
            id: '456',
            label: 'Palwancha',
            value: 'palwancha',
        },
        {
            id: '472',
            label: 'Mandamarri',
            value: 'mandamarri',
        },
        {
            id: '475',
            label: 'Koratla',
            value: 'koratla',
        },
        {
            id: '482',
            label: 'Sircilla',
            value: 'sircilla',
        },
        {
            id: '487',
            label: 'Tandur',
            value: 'tandur',
        },
        {
            id: '505',
            label: 'Siddipet',
            value: 'siddipet',
        },
        {
            id: '514',
            label: 'Wanaparthy',
            value: 'wanaparthy',
        },
        {
            id: '541',
            label: 'Kagaznagar',
            value: 'kagaznagar',
        },
        {
            id: '542',
            label: 'Gadwal',
            value: 'gadwal',
        },
        {
            id: '545',
            label: 'Sangareddy',
            value: 'sangareddy',
        },
        {
            id: '574',
            label: 'Bellampalle',
            value: 'bellampalle',
        },
        {
            id: '584',
            label: 'Bhongir',
            value: 'bhongir',
        },
        {
            id: '587',
            label: 'Vikarabad',
            value: 'vikarabad',
        },
        {
            id: '592',
            label: 'Jangaon',
            value: 'jangaon',
        },
        {
            id: '617',
            label: 'Bhadrachalam',
            value: 'bhadrachalam',
        },
        {
            id: '624',
            label: 'Bhainsa',
            value: 'bhainsa',
        },
        {
            id: '668',
            label: 'Farooqnagar',
            value: 'farooqnagar',
        },
        {
            id: '713',
            label: 'Medak',
            value: 'medak',
        },
        {
            id: '714',
            label: 'Narayanpet',
            value: 'narayanpet',
        },
        {
            id: '784',
            label: 'Sadasivpet',
            value: 'sadasivpet',
        },
        {
            id: '833',
            label: 'Yellandu',
            value: 'yellandu',
        },
        {
            id: '849',
            label: 'Manuguru',
            value: 'manuguru',
        },
        {
            id: '863',
            label: 'Kyathampalle',
            value: 'kyathampalle',
        },
        {
            id: '983',
            label: 'Nagarkurnool',
            value: 'nagarkurnool',
        },
    ],
    tripura: [
        {
            id: '97',
            label: 'Agartala',
            value: 'agartala',
        },
        {
            id: '850',
            label: 'Udaipur',
            value: 'udaipur',
        },
        {
            id: '898',
            label: 'Dharmanagar',
            value: 'dharmanagar',
        },
        {
            id: '981',
            label: 'Pratapgarh',
            value: 'pratapgarh',
        },
        {
            id: '1182',
            label: 'Kailasahar',
            value: 'kailasahar',
        },
        {
            id: '1191',
            label: 'Belonia',
            value: 'belonia',
        },
        {
            id: '1196',
            label: 'Khowai',
            value: 'khowai',
        },
    ],
    'uttar pradesh': [
        {
            id: '11',
            label: 'Lucknow',
            value: 'lucknow',
        },
        {
            id: '12',
            label: 'Kanpur',
            value: 'kanpur',
        },
        {
            id: '20',
            label: 'Firozabad',
            value: 'firozabad',
        },
        {
            id: '23',
            label: 'Agra',
            value: 'agra',
        },
        {
            id: '28',
            label: 'Meerut',
            value: 'meerut',
        },
        {
            id: '31',
            label: 'Varanasi',
            value: 'varanasi',
        },
        {
            id: '37',
            label: 'Allahabad',
            value: 'allahabad',
        },
        {
            id: '46',
            label: 'Amroha',
            value: 'amroha',
        },
        {
            id: '47',
            label: 'Moradabad',
            value: 'moradabad',
        },
        {
            id: '49',
            label: 'Aligarh',
            value: 'aligarh',
        },
        {
            id: '60',
            label: 'Saharanpur',
            value: 'saharanpur',
        },
        {
            id: '64',
            label: 'Noida',
            value: 'noida',
        },
        {
            id: '78',
            label: 'Loni',
            value: 'loni',
        },
        {
            id: '79',
            label: 'Jhansi',
            value: 'jhansi',
        },
        {
            id: '110',
            label: 'Shahjahanpur',
            value: 'shahjahanpur',
        },
        {
            id: '127',
            label: 'Rampur',
            value: 'rampur',
        },
        {
            id: '130',
            label: 'Modinagar',
            value: 'modinagar',
        },
        {
            id: '134',
            label: 'Hapur',
            value: 'hapur',
        },
        {
            id: '140',
            label: 'Etawah',
            value: 'etawah',
        },
        {
            id: '157',
            label: 'Sambhal',
            value: 'sambhal',
        },
        {
            id: '178',
            label: 'Orai',
            value: 'orai',
        },
        {
            id: '179',
            label: 'Bahraich',
            value: 'bahraich',
        },
        {
            id: '188',
            label: 'Unnao',
            value: 'unnao',
        },
        {
            id: '196',
            label: 'Rae Bareli',
            value: 'rae bareli',
        },
        {
            id: '221',
            label: 'Lakhimpur',
            value: 'lakhimpur',
        },
        {
            id: '222',
            label: 'Sitapur',
            value: 'sitapur',
        },
        {
            id: '252',
            label: 'Lalitpur',
            value: 'lalitpur',
        },
        {
            id: '264',
            label: 'Pilibhit',
            value: 'pilibhit',
        },
        {
            id: '288',
            label: 'Chandausi',
            value: 'chandausi',
        },
        {
            id: '292',
            label: 'Hardoi ',
            value: 'hardoi ',
        },
        {
            id: '297',
            label: 'Azamgarh',
            value: 'azamgarh',
        },
        {
            id: '324',
            label: 'Khair',
            value: 'khair',
        },
        {
            id: '332',
            label: 'Sultanpur',
            value: 'sultanpur',
        },
        {
            id: '347',
            label: 'Tanda',
            value: 'tanda',
        },
        {
            id: '349',
            label: 'Nagina',
            value: 'nagina',
        },
        {
            id: '362',
            label: 'Shamli',
            value: 'shamli',
        },
        {
            id: '369',
            label: 'Najibabad',
            value: 'najibabad',
        },
        {
            id: '372',
            label: 'Shikohabad',
            value: 'shikohabad',
        },
        {
            id: '453',
            label: 'Sikandrabad',
            value: 'sikandrabad',
        },
        {
            id: '461',
            label: 'Shahabad, Hardoi',
            value: 'shahabad, hardoi',
        },
        {
            id: '469',
            label: 'Pilkhuwa',
            value: 'pilkhuwa',
        },
        {
            id: '471',
            label: 'Renukoot',
            value: 'renukoot',
        },
        {
            id: '495',
            label: 'Vrindavan',
            value: 'vrindavan',
        },
        {
            id: '500',
            label: 'Ujhani',
            value: 'ujhani',
        },
        {
            id: '502',
            label: 'Laharpur',
            value: 'laharpur',
        },
        {
            id: '510',
            label: 'Tilhar',
            value: 'tilhar',
        },
        {
            id: '535',
            label: 'Sahaswan',
            value: 'sahaswan',
        },
        {
            id: '559',
            label: 'Rath',
            value: 'rath',
        },
        {
            id: '589',
            label: 'Sherkot',
            value: 'sherkot',
        },
        {
            id: '600',
            label: 'Kalpi',
            value: 'kalpi',
        },
        {
            id: '612',
            label: 'Tundla',
            value: 'tundla',
        },
        {
            id: '636',
            label: 'Sandila',
            value: 'sandila',
        },
        {
            id: '639',
            label: 'Nanpara',
            value: 'nanpara',
        },
        {
            id: '640',
            label: 'Sardhana',
            value: 'sardhana',
        },
        {
            id: '645',
            label: 'Nehtaur',
            value: 'nehtaur',
        },
        {
            id: '649',
            label: 'Seohara',
            value: 'seohara',
        },
        {
            id: '679',
            label: 'Padrauna',
            value: 'padrauna',
        },
        {
            id: '684',
            label: 'Mathura',
            value: 'mathura',
        },
        {
            id: '685',
            label: 'Thakurdwara',
            value: 'thakurdwara',
        },
        {
            id: '740',
            label: 'Nawabganj',
            value: 'nawabganj',
        },
        {
            id: '743',
            label: 'Siana',
            value: 'siana',
        },
        {
            id: '746',
            label: 'Noorpur',
            value: 'noorpur',
        },
        {
            id: '757',
            label: 'Sikandra Rao',
            value: 'sikandra rao',
        },
        {
            id: '769',
            label: 'Puranpur',
            value: 'puranpur',
        },
        {
            id: '776',
            label: 'Rudauli',
            value: 'rudauli',
        },
        {
            id: '781',
            label: 'Thana Bhawan',
            value: 'thana bhawan',
        },
        {
            id: '804',
            label: 'Palia Kalan',
            value: 'palia kalan',
        },
        {
            id: '813',
            label: 'Zaidpur',
            value: 'zaidpur',
        },
        {
            id: '831',
            label: 'Nautanwa',
            value: 'nautanwa',
        },
        {
            id: '840',
            label: 'Zamania',
            value: 'zamania',
        },
        {
            id: '844',
            label: 'Shikarpur, Bulandshahr',
            value: 'shikarpur, bulandshahr',
        },
        {
            id: '847',
            label: 'Naugawan Sadat',
            value: 'naugawan sadat',
        },
        {
            id: '848',
            label: 'Fatehpur Sikri',
            value: 'fatehpur sikri',
        },
        {
            id: '864',
            label: 'Shahabad, Rampur',
            value: 'shahabad, rampur',
        },
        {
            id: '870',
            label: 'Robertsganj',
            value: 'robertsganj',
        },
        {
            id: '874',
            label: 'Utraula',
            value: 'utraula',
        },
        {
            id: '879',
            label: 'Sadabad',
            value: 'sadabad',
        },
        {
            id: '926',
            label: 'Rasra',
            value: 'rasra',
        },
        {
            id: '942',
            label: 'Lar',
            value: 'lar',
        },
        {
            id: '943',
            label: 'Lal Gopalganj Nindaura',
            value: 'lal gopalganj nindaura',
        },
        {
            id: '945',
            label: 'Sirsaganj',
            value: 'sirsaganj',
        },
        {
            id: '966',
            label: 'Pihani',
            value: 'pihani',
        },
        {
            id: '973',
            label: 'Shamsabad, Agra',
            value: 'shamsabad, agra',
        },
        {
            id: '986',
            label: 'Rudrapur',
            value: 'rudrapur',
        },
        {
            id: '987',
            label: 'Soron',
            value: 'soron',
        },
        {
            id: '999',
            label: 'Gorakhpur',
            value: 'gorakhpur',
        },
        {
            id: '1019',
            label: 'Samdhan',
            value: 'samdhan',
        },
        {
            id: '1026',
            label: 'Sahjanwa',
            value: 'sahjanwa',
        },
        {
            id: '1032',
            label: 'Rampur Maniharan',
            value: 'rampur maniharan',
        },
        {
            id: '1036',
            label: 'Sumerpur',
            value: 'sumerpur',
        },
        {
            id: '1038',
            label: 'Shahganj',
            value: 'shahganj',
        },
        {
            id: '1040',
            label: 'Tulsipur',
            value: 'tulsipur',
        },
        {
            id: '1050',
            label: 'Tirwaganj',
            value: 'tirwaganj',
        },
        {
            id: '1063',
            label: 'Deoria',
            value: 'deoria',
        },
        {
            id: '1064',
            label: 'Shamsabad, Farrukhabad',
            value: 'shamsabad, farrukhabad',
        },
        {
            id: '1067',
            label: 'Warhapur',
            value: 'warhapur',
        },
        {
            id: '1071',
            label: 'Powayan',
            value: 'powayan',
        },
        {
            id: '1076',
            label: 'Sandi',
            value: 'sandi',
        },
        {
            id: '1094',
            label: 'Achhnera',
            value: 'achhnera',
        },
        {
            id: '1096',
            label: 'Naraura',
            value: 'naraura',
        },
        {
            id: '1097',
            label: 'Nakur',
            value: 'nakur',
        },
        {
            id: '1102',
            label: 'Sahaspur',
            value: 'sahaspur',
        },
        {
            id: '1108',
            label: 'Safipur',
            value: 'safipur',
        },
        {
            id: '1118',
            label: 'Reoti',
            value: 'reoti',
        },
        {
            id: '1135',
            label: 'Sikanderpur',
            value: 'sikanderpur',
        },
        {
            id: '1140',
            label: 'Saidpur',
            value: 'saidpur',
        },
        {
            id: '1146',
            label: 'Sirsi',
            value: 'sirsi',
        },
        {
            id: '1147',
            label: 'Purwa',
            value: 'purwa',
        },
        {
            id: '1150',
            label: 'Parasi',
            value: 'parasi',
        },
        {
            id: '1152',
            label: 'Lalganj',
            value: 'lalganj',
        },
        {
            id: '1158',
            label: 'Phulpur',
            value: 'phulpur',
        },
        {
            id: '1172',
            label: 'Shishgarh',
            value: 'shishgarh',
        },
        {
            id: '1178',
            label: 'Sahawar',
            value: 'sahawar',
        },
        {
            id: '1183',
            label: 'Samthar',
            value: 'samthar',
        },
        {
            id: '1189',
            label: 'Pukhrayan',
            value: 'pukhrayan',
        },
        {
            id: '1202',
            label: 'Obra',
            value: 'obra',
        },
        {
            id: '1208',
            label: 'Niwai',
            value: 'niwai',
        },
        {
            id: '1219',
            label: 'Mirzapur',
            value: 'mirzapur',
        },
    ],
    uttarakhand: [
        {
            id: '71',
            label: 'Dehradun',
            value: 'dehradun',
        },
        {
            id: '151',
            label: 'Hardwar',
            value: 'hardwar',
        },
        {
            id: '215',
            label: 'Haldwani-cum-Kathgodam',
            value: 'haldwani-cum-kathgodam',
        },
        {
            id: '229',
            label: 'Srinagar',
            value: 'srinagar',
        },
        {
            id: '270',
            label: 'Kashipur',
            value: 'kashipur',
        },
        {
            id: '284',
            label: 'Roorkee',
            value: 'roorkee',
        },
        {
            id: '367',
            label: 'Rudrapur',
            value: 'rudrapur',
        },
        {
            id: '406',
            label: 'Rishikesh',
            value: 'rishikesh',
        },
        {
            id: '661',
            label: 'Ramnagar',
            value: 'ramnagar',
        },
        {
            id: '673',
            label: 'Pithoragarh',
            value: 'pithoragarh',
        },
        {
            id: '701',
            label: 'Manglaur',
            value: 'manglaur',
        },
        {
            id: '718',
            label: 'Nainital',
            value: 'nainital',
        },
        {
            id: '924',
            label: 'Mussoorie',
            value: 'mussoorie',
        },
        {
            id: '1018',
            label: 'Tehri',
            value: 'tehri',
        },
        {
            id: '1035',
            label: 'Pauri',
            value: 'pauri',
        },
        {
            id: '1115',
            label: 'Nagla',
            value: 'nagla',
        },
        {
            id: '1121',
            label: 'Sitarganj',
            value: 'sitarganj',
        },
        {
            id: '1209',
            label: 'Bageshwar',
            value: 'bageshwar',
        },
    ],
    'west bengal': [
        {
            id: '7',
            label: 'Kolkata',
            value: 'kolkata',
        },
        {
            id: '24',
            label: 'Siliguri',
            value: 'siliguri',
        },
        {
            id: '72',
            label: 'Asansol',
            value: 'asansol',
        },
        {
            id: '108',
            label: 'Raghunathganj',
            value: 'raghunathganj',
        },
        {
            id: '121',
            label: 'Kharagpur',
            value: 'kharagpur',
        },
        {
            id: '156',
            label: 'Naihati',
            value: 'naihati',
        },
        {
            id: '160',
            label: 'English Bazar',
            value: 'english bazar',
        },
        {
            id: '175',
            label: 'Baharampur',
            value: 'baharampur',
        },
        {
            id: '189',
            label: 'Hugli-Chinsurah',
            value: 'hugli-chinsurah',
        },
        {
            id: '190',
            label: 'Raiganj',
            value: 'raiganj',
        },
        {
            id: '197',
            label: 'Jalpaiguri',
            value: 'jalpaiguri',
        },
        {
            id: '224',
            label: 'Santipur',
            value: 'santipur',
        },
        {
            id: '225',
            label: 'Balurghat',
            value: 'balurghat',
        },
        {
            id: '230',
            label: 'Medinipur',
            value: 'medinipur',
        },
        {
            id: '231',
            label: 'Habra',
            value: 'habra',
        },
        {
            id: '236',
            label: 'Ranaghat',
            value: 'ranaghat',
        },
        {
            id: '247',
            label: 'Bankura',
            value: 'bankura',
        },
        {
            id: '260',
            label: 'Nabadwip',
            value: 'nabadwip',
        },
        {
            id: '272',
            label: 'Darjiling',
            value: 'darjiling',
        },
        {
            id: '289',
            label: 'Purulia',
            value: 'purulia',
        },
        {
            id: '477',
            label: 'Arambagh',
            value: 'arambagh',
        },
        {
            id: '483',
            label: 'Tamluk',
            value: 'tamluk',
        },
        {
            id: '485',
            label: 'AlipurdUrban Agglomerationr',
            value: 'alipurdurban agglomerationr',
        },
        {
            id: '506',
            label: 'Suri',
            value: 'suri',
        },
        {
            id: '508',
            label: 'Jhargram',
            value: 'jhargram',
        },
        {
            id: '556',
            label: 'Gangarampur',
            value: 'gangarampur',
        },
        {
            id: '609',
            label: 'Rampurhat',
            value: 'rampurhat',
        },
        {
            id: '696',
            label: 'Kalimpong',
            value: 'kalimpong',
        },
        {
            id: '742',
            label: 'Sainthia',
            value: 'sainthia',
        },
        {
            id: '751',
            label: 'Taki',
            value: 'taki',
        },
        {
            id: '773',
            label: 'Murshidabad',
            value: 'murshidabad',
        },
        {
            id: '787',
            label: 'Memari',
            value: 'memari',
        },
        {
            id: '893',
            label: 'Paschim Punropara',
            value: 'paschim punropara',
        },
        {
            id: '896',
            label: 'Tarakeswar',
            value: 'tarakeswar',
        },
        {
            id: '972',
            label: 'Sonamukhi',
            value: 'sonamukhi',
        },
        {
            id: '975',
            label: 'PandUrban Agglomeration',
            value: 'pandurban agglomeration',
        },
        {
            id: '976',
            label: 'Mainaguri',
            value: 'mainaguri',
        },
        {
            id: '1078',
            label: 'Malda',
            value: 'malda',
        },
        {
            id: '1120',
            label: 'Panchla',
            value: 'panchla',
        },
        {
            id: '1125',
            label: 'Raghunathpur',
            value: 'raghunathpur',
        },
        {
            id: '1154',
            label: 'Mathabhanga',
            value: 'mathabhanga',
        },
        {
            id: '1167',
            label: 'Monoharpur',
            value: 'monoharpur',
        },
        {
            id: '1193',
            label: 'Srirampore',
            value: 'srirampore',
        },
        {
            id: '1200',
            label: 'Adra',
            value: 'adra',
        },
    ],
}

export const bookingDuration = [
    { label: 'less than 7 days', value: 'less than 7 days' },
    { label: '7 days to 45 days', value: '7 days to 45 days' },
    { label: '45 days to 90 days', value: '45 days to 90 days' },
    { label: 'more than 90 days', value: 'more than 90 days' },
]
